import React from "react";

import BsyDashBase from "../BsyDashBase";
import { BsyConfig } from "../../../global/BsyConfig";
import { BsyDashUtils } from "../../../utils/DashUtils";
// import { echarts } from '../../../plugins/echarts.esm.min.js';

import "./index.css";
import { BsyUtils } from "../../../utils/Utils";
import BsySLoading from "../../BsySLoading";
import { getAfterSuffix } from "../../../utils/getAfterSuffix";

export default class BsyDashChartBase extends BsyDashBase {
  static defaultProps = {
    height: 230,
    width: 200,
    mode: "visit",
    url: "/data/report_combined_group",
    isLayoutEdit: !1,
    autoLoad: true,
    mountAutoLoad: true,
    form: null,
    xFields: [],
    yFields: [],

    xAxis: {
      label: {
        enable: !0,
      },
    },
    yAxes: [],
    top: {},
    metrics: [],
    sort: [],
    thresholds: [],
    thresholdColor: "#E64340",
    filter: null,
    onDataFilter: null,
    onItemClick: null,
    onLoadFail: null,
    onHeadToolUpdate: null,
    componentAttr: null,
    region_area: {},
    drilling: "pc",
    region: "country",
    map_type: "area",
    mapDataUrl: window.rootDirectroy + "/geojson/2020-12-22/${adcode}.json",
    range: "0,100",
    // mapDataUrl:"/geojson/2020-12-22/${adcode}.json"
    attrList: {
      title: {
        show: false,
        text: "标题内容",
        textStyle: {
          color: "#333333",
          fontStyle: "normal",
          fontSize: 16,
          fontWeight: "normal",
        },
        left: "left", //'left', 'center', 'right'
        borderColor: "transparent",
        borderWidth: 2,
        padding: 5,
        onBorderColor: false,
        borderRadius: 0,
        backgroundColor: "transparent", // 'rgba(128, 128, 128, 0.5)'
      },
      orient: "vertical",
      legend: {
        textStyle: {
          // color:"#333333",
          fontStyle: "normal",
          fontSize: 10,
          fontWeight: "normal",
        },
        itemWidth: 12,
        itemHeight: 12,
        position: "bottom",
        type: "plain",
        padding: 10,
      },
      itemStyle: {
        opacity: 0.7,

        borderWidth: 2,
      },
      tooltip: {
        show: true,
        triggerOn: "mousemove",
        position: "0",
        seriesName: "",
        formatter: "1",
        opacity: 1,
        // backgroundColor:"rgba(50,50,50,0.7)",
        textStyle: {
          color: "#FFFFFF",
          fontStyle: "normal",
          fontSize: 14,
          fontWeight: "normal",
        },
      },
      label: {
        // color:"#333333",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 10,
        position: "top",
        formatter: "1",
      },
    },
    tooltip: {
      show: true,
      triggerOn: "mousemove",
      position: "0",
      seriesName: "",
      formatter: "1",
      opacity: 1,
      // backgroundColor:"rgba(50,50,50,0.7)",
      textStyle: {
        color: "#FFFFFF",
        fontStyle: "normal",
        fontSize: 14,
        fontWeight: "normal",
      },
    },
    legend: {
      enable: !0,
      type: "scroll",
      bottom: 0,
      padding: 10,
      itemWidth: 12,
      itemHeight: 12,
      textStyle: {
        fontStyle: "normal",
      },
    },
    chart_label: {
      enable: !0,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      url: props.url,
      mode: props.mode,
      isLayoutEdit: props.isLayoutEdit,
      form: props.form,
      isLoading: false,
      appId: props.appId,
      entryId: props.entryId,
      column_type: props.column_type,
      xFields: [...props.xFields],
      yFields: [...props.yFields],
      xAxis: { ...props.xAxis },
      yAxes: [...props.yAxes],
      top: { ...props.top },
      valueFields: [...props.metrics],
      sort: [...props.defaultSort],
      thresholds: [...props.thresholds],
      thresholdColor: props.thresholdColor,
      filter: props.filter,
      onDataFilter: props.onDataFilter,
      onItemClick: props.onItemClick,
      onLoadFail: props.onLoadFail,
      onHeadToolUpdate: props.onHeadToolUpdate,
      componentAttr: props.componentAttr,
      attrList: { ...props.attrList },
      tooltip: { ...props.tooltip },
      legend: { ...props.legend },
      chart_label: { ...props.chart_label },
      regionArea: { ...props.region_area },
      region: props.region,
      mapType: props.map_type,
      mapDataUrl: props.mapDataUrl,
      chartType: props.type,
      widgetId: props.widgetId,
      range: props.range,
      drilling: props.drilling,
      autoLoad: props.autoLoad,
      dataEmpty: false,
    };
    this.DEFAULT_COLORS = [
      "#1397DC",
      "#12C1EC",
      "#6FE498",
      "#F5D04F",
      "#FF9F7F",
      "#FB7293",
      "#DA99EC",
      "#8378EA",
    ];
    // this.props.chartType = props.type
    this.echartsRef = React.createRef();
    this.linkParam = null;
    this.isDashFull = props.isDashFull;
  }

  // column_chart

  initprops = () => {
    this._renderStyles();
    this.left_offset = 20;
    this.right_offset = 20;
    this.top_offset = 20;
    this.botton_offset = 30;
    this.rotation_botton_offse = 20;
  };

  componentDidMount() {
    this.initprops();
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this._addCustomChartOptions();
    if (!this.props.mountAutoLoad) {
      return;
    }

    this.loadWidget();
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.isDashFull !== this.isDashFull) {
      this.isDashFull = nextProps.isDashFull;
      this.setState({});
    }
  }

  loadWidget = (n, d) => {
    const { autoRefresh } = this.props;

    if (n === "isFull" && autoRefresh.enabled) {
      this.randomDataLoad(n, d);
    } else {
      this.loadData();
    }
  };

  _getFirstValidFormatIndex = () => {
    let t = this,
      i = 0;
    const { valueFields } = this.state;
    BsyUtils.forEach(valueFields, function (e, n) {
      if (n && !t._isDefaultFormat(n)) return (i = e), !1;
    });
    return i;
  };
  _isDefaultFormat = (t) => {
    let e = !1;
    BsyUtils.isEmpty(t.format)
      ? (e = !0)
      : "preset" === t.formatType && "0." === t.format && (e = !0);
    return e;
  };
  _addCustomChartOptions = () => {};

  _dealLinkData = (t, e) => {
    let i = e;
    switch (t.type) {
      case "datetime":
        i = BsyUtils.getDateRange(e);
        break;
      case "address":
      case "location":
        i = BsyUtils.getArrayFromRange(i, "address");
        break;
      case "assist_flowid": {
        i = null;
        BsyUtils.forEach(this.flowIdNameMap, (key, val) => {
          if (e === val) {
            i = Number(key);
            return false;
          }
        });
        break;
      }
      case "flowState":
      case "flowstate":
        let n = BsyConfig().CONST.WORKFLOW.FLOWSTATE,
          r = {};
        r[React.language("flow.state.inProcess")] = n.INPROCESS;
        r[React.language("flow.state.complete")] = n.COMPLETE;
        r[React.language("flow.state.closed")] = n.CLOSE;
        i = r[i];
        break;
      case "flowdecision":
      case "flowDecision":
        i = this.flowDecisionMap[i];
        break;
      case "user":
      case "dept": {
        i =
          (this.nameMap[i] && (this.nameMap[i]._id || this.nameMap[i].id)) || i;
        break;
      }
      default: {
        break;
      }
    }
    return BsyUtils.getLinkFilter(t, i);
  };

  _getLinkFilterParams = (e) => {
    let i = this.props,
      a = [];
    BsyUtils.forEach(e, function (e, n) {
      // t.extend(BsyUtils.pick(n, ["method", "type", "value", "keyType"]), FX.Utils.dealFilterInfoByField({
      //   id: i.forms[0],
      //   name: n.field
      // })
      a.push({
        ...BsyUtils.pick(n, ["method", "type", "value", "keyType"]),
        ...BsyUtils.dealFilterInfoByField({
          id: i.forms[0],
          name: n.field,
        }),
      });
    });
    return a;
  };

  getFilterData = (t) => {
    let e = this.props,
      i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1),
      a = [];
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    i && (a = a.concat(i));
    BsyUtils.isObjectEmpty(t) || (a = a.concat(t));
    e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond));
    return BsyUtils.isObjectEmpty(a)
      ? {}
      : {
          cond: a,
          rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND,
        };
  };

  randomDataLoad = (n, d) => {
    const { url, regionArea, region, valueFields, sort, isLoading } =
      this.state;
    const { widgetId, appId, entryId, forms } = this.props;

    // if (forms[0].indexOf("@") > -1) {
    //     if (d.formId !== forms[0].split("@")[0]) {
    //         this.props.onLoadFail && this.props.onLoadFail(n, d)
    //         return
    //     }
    // } else {
    //     if (!d) {
    //         this.props.onLoadFail && this.props.onLoadFail(n, d)
    //         return
    //     }

    //     if (d.formId !== forms[0]) {
    //         this.props.onLoadFail && this.props.onLoadFail(n, d)
    //         return
    //     }
    // }

    if (isLoading) return;
    this.isDashFull = n;
    this._setGroups();
    this.setState(
      {
        isLoading: true,
      },
      () => {
        React.axios(
          url,
          {
            appId: appId,
            entryId: entryId,
            widgetId: widgetId,
            sort: sort,
            filter: this.getFilterData(this.linkParam),
            region_area: regionArea || null,
            region: region || null,
            env: this.props.env || undefined,
          },
          { dashMode: n, autoShowMsg: this.props.env === "dashboard" }
        )
          .then((res) => {
            this.setState(
              {
                isLoading: false,
              },
              () => {
                this.reftype = res.data.reftype;
                BsyUtils.forEach(res.data.user, function (a1, b1) {
                  b1.nickname = BsyUtils._toDeptUser(b1, "user");
                });

                BsyUtils.showAjaxTip(
                  res.data,
                  () => {
                    this.chartUtils = new DashChartUtils({
                      yGroups: this.yGroups,
                      xGroups: this.xGroups,
                      valueFields: valueFields,
                      data: res.data.data,
                      userMap: res.data.user,
                      departmentMap: res.data.department,
                      region: res.data.region,
                    }).getChartData();

                    this.metrics = res.data.metrics;
                    this.guidelineVal = res.data.guideline_val;
                    this.nameMap = this.chartUtils.nameMap;
                    this.flowIdNameMap = this.chartUtils.flowIdNameMap;
                    this.tags = this.chartUtils.tags;

                    this._getStyles();

                    if (
                      !this.chartUtils.data ||
                      this.chartUtils.data.length === 0
                    ) {
                      if (this.myCharts) {
                        this.myCharts.dispose();
                        this.echartsRef.current.innerHTML = "";
                        this.myCharts = null;
                      }
                      this.setState(
                        {
                          dataEmpty: true,
                        },
                        () => {
                          BsyUtils.applyFunc(
                            this,
                            this.props.onLoadSuccess,
                            [res.data, n, d],
                            !1
                          );
                        }
                      );
                    } else {
                      let rrd = () => {
                        // if (this.state.chartType === "map_chart") {
                        //     this._initChartOption(!1, this.chartUtils.series, this.chartUtils.category, this.chartUtils.data, res.data)
                        // } else
                        {
                          let options = this._renderOptions(
                            {},
                            this.chartUtils.series,
                            this.chartUtils.category,
                            this.chartUtils.data,
                            res.data
                          );
                          if (this.myCharts) {
                            this.myCharts.setOption(options, {
                              notMerge: false,
                              lazyUpdate: false,
                              silent: false,
                            });
                          } else {
                            this._initChartOption(
                              !1,
                              this.chartUtils.series,
                              this.chartUtils.category,
                              this.chartUtils.data,
                              res.data
                            );
                          }
                        }
                        BsyUtils.applyFunc(
                          this,
                          this.props.onLoadSuccess,
                          [res.data, n, d],
                          !1
                        );
                      };

                      if (this.state.dataEmpty) {
                        this.setState(
                          {
                            dataEmpty: false,
                          },
                          () => {
                            rrd();
                          }
                        );
                      } else {
                        rrd();
                      }
                    }
                  },
                  () => {
                    this.props.onLoadFail && this.props.onLoadFail(n, d);
                  }
                );
              }
            );
          })
          .catch((res) => {
            this.props.onLoadFail && this.props.onLoadFail(n, d);
            console.error(res);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  loadData = (n, d) => {
    const { url, regionArea, region, valueFields, sort, isLoading } =
      this.state;
    const { widgetId, appId, entryId, autoRefresh } = this.props;

    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad) autoload = this.props.onIsAutoLoad();

    if (!autoload) {
      this.setState({
        dataEmpty: true,
      });
      return;
    }

    if (isLoading) return;
    this.isDashFull = n;
    this._setGroups();
    this.setState(
      {
        isLoading: true,
      },
      () => {
        React.axios(
          url,
          {
            appId: appId,
            entryId: entryId,
            widgetId: widgetId,
            sort: sort,
            filter: this.getFilterData(null),
            region_area: regionArea || null,
            region: region || null,
            env: this.props.env || undefined,
          },
          { dashMode: n, autoShowMsg: this.props.env === "dashboard" }
        )
          .then((res) => {
            if (res.data.hasOwnProperty("code") && res.data.code === 3000) {
              //onConfigError
              if (this.props.onConfigError) {
                this.props.onConfigError(res.data);
              }
              if (this.props.onLoadFail) {
                this.props.onLoadFail(n, d);
              }
              return;
            }

            this.setState(
              {
                isLoading: false,
              },
              () => {
                this.reftype = res.data.reftype;
                BsyUtils.showAjaxTip(
                  res.data,
                  () => {
                    BsyUtils.forEach(res.data.user, function (a1, b1) {
                      b1.nickname = BsyUtils._toDeptUser(b1, "user");
                    });

                    BsyUtils.forEach(res.data.department, function (a1, b1) {
                      b1.name = BsyUtils._toDeptUser(b1, "user");
                    });

                    this.chartUtils = new DashChartUtils({
                      yGroups: this.yGroups,
                      xGroups: this.xGroups,
                      valueFields: valueFields,
                      data: res.data.data,
                      userMap: res.data.user,
                      departmentMap: res.data.department,
                      flowIdNameMap: res.data.flowIdName,
                      region: res.data.region,
                    }).getChartData();

                    this.metrics = res.data.metrics;
                    this.guidelineVal = res.data.guideline_val;
                    this.nameMap = this.chartUtils.nameMap;
                    this.tags = this.chartUtils.tags;
                    this.flowIdNameMap = this.chartUtils.flowIdNameMap;
                    this.flowDecisionMap = this.chartUtils.flowDecisionMap;

                    this._getStyles();
                    if (
                      !this.chartUtils.data ||
                      this.chartUtils.data.length === 0
                    ) {
                      if (this.myCharts) {
                        this.myCharts.dispose();
                        this.echartsRef.current.innerHTML = "";
                        this.myCharts = null;
                      }
                      this.setState(
                        {
                          dataEmpty: true,
                        },
                        () => {
                          BsyUtils.applyFunc(
                            this,
                            this.props.onLoadSuccess,
                            [res.data, n, d],
                            !1
                          );
                        }
                      );
                    } else {
                      let rdd = () => {
                        this._initChartOption(
                          !1,
                          this.chartUtils.series,
                          this.chartUtils.category,
                          this.chartUtils.data,
                          res.data
                        );
                        BsyUtils.applyFunc(
                          this,
                          this.props.onLoadSuccess,
                          [res.data, n, d],
                          !1
                        );
                      };
                      if (this.state.dataEmpty) {
                        this.setState(
                          {
                            dataEmpty: false,
                          },
                          () => {
                            rdd();
                          }
                        );
                      } else {
                        rdd();
                      }
                    }

                    // this.setState({
                    //     isLoading: false,
                    // },()=>{

                    // })
                  },
                  () => {
                    if (this.props.onLoadFail) {
                      this.props.onLoadFail(n, d);
                    }
                  }
                );
              }
            );
          })
          .catch((res) => {
            if (this.props.onConfigError) {
              if (res.status) {
                this.props.onConfigError(res.data);
              }
            }
            if (this.props.onLoadFail) {
              this.props.onLoadFail(n, d)
            }
            console.error(res);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  doClearLink = () => {
    let t = this.props;
    BsyUtils.applyFunc(this, t.onClearLink, [this.linkParam], null);
    this.linkParam = null;
  };

  _getStyles = (dashStyles, styles) => {
    const { attrList, chartType, widgetId } = this.state;
    let t = this.props;
    // dashStyles = dashStyles || this.props.dashStyles;
    // // this.props.dashStyles = dashStyles;
    // styles = styles || this.props.styles;
    // // this.props.styles = styles;

    let style = BsyUtils.applyFunc(
      this,
      this.props.onGetStyles,
      [widgetId],
      !1
    );

    this.palette = t.palette;
    //标签颜色
    this.textColor = "#000000";
    this.tickLabelColor = "#000000";
    //图例颜色
    this.legendColor = "#666666";
    //指标颜色
    this.indicatorColor = "#666666";

    //图片背景的浅色分割线
    this.splitColor = "#eeeeee";

    this.tooltipColor = "rgba(50,50,50,0.7)";
    this.attrList = JSON.parse(JSON.stringify(attrList));

    if (style) {
      if (style.theme.palette) {
        if (chartType === "map_chart") {
          if (t.palette === "default" || !t.palette) {
            this.palette = style.theme.gradation;
            // t.color = null;
          }
        } else {
          if (t.palette === "default" || !t.palette) {
            this.palette = style.theme.palette;
          }
        }
      } else {
        if (t.palette === "default" || !t.palette) {
          this.palette = t.palette;
        }
      }

      switch (style.theme.name) {
        case "preset_style_dark_1":
        case "preset_style_dark_2":
        case "preset_style_dark_3": {
          this.textColor = "#ffffff";
          this.tickLabelColor = "#ffffff";
          this.indicatorColor = "#dddddd";
          this.legendColor = "#ffffff";
          this.splitColor = "#aaaaaa";
          break;
        }
        default: {
          break;
        }
      }

      if (this.attrList && this.attrList.label && this.attrList.label.color) {
        this.textColor = this.attrList.label.color;
      } else {
        this.attrList.label.color = this.textColor;
      }
      if (
        this.attrList &&
        this.attrList.legend &&
        this.attrList.legend.textStyle.color
      ) {
        this.legendColor = this.attrList.legend.textStyle.color;
      } else {
        if (!this.attrList.legend) {
          this.attrList.legend = {
            textStyle: {
              color: this.legendColor,
            },
          };
        } else {
          this.attrList.legend.textStyle.color = this.legendColor;
        }
      }

      if (
        this.attrList &&
        this.attrList.tooltip &&
        this.attrList.tooltip.backgroundColor
      ) {
        this.tooltipColor = this.attrList.tooltip.backgroundColor;
      } else {
        if (!this.attrList.tooltip) {
          this.attrList.tooltip = {
            show: true,
            triggerOn: "mousemove",
            position: "0",
            seriesName: "",
            formatter: "1",
            opacity: 1,
            backgroundColor: this.tooltipColor,
            textStyle: {
              color: "#FFFFFF",
              fontStyle: "normal",
              fontSize: 14,
              fontWeight: "normal",
            },
          };
        } else {
          this.attrList.tooltip.backgroundColor = this.tooltipColor;
        }
      }
    }
    if (this.palette === "default") {
      this.palette = "preset_1";
      if (chartType === "map_chart") this.palette = "preset_map_1";
    }
    // BsyUtils.applyFunc(this, t.onRenderBackground, [styles || t.styles], !1);
    return style;
  };

  _checkFields = () => {
    const { xFields, yFields, valueFields } = this.state;
    return (xFields.length > 0 || yFields.length > 0) && valueFields.length > 0;
  };
  _setGroups = () => {
    const { xFields, valueFields } = this.state;
    xFields && xFields.length > 0 && (this.xGroups = xFields.slice(0, 1));
    xFields &&
      xFields.length > 1 &&
      valueFields.length <= 1 &&
      (this.yGroups = xFields.slice(1, 2));
  };
  _calculateValueNiceDomain = (t, e, n, a) => {
    let o = this.props,
      s = false,
      h = false;

    if ((t = s ? n : t) >= (e = h ? a : e)) {
      e = t + 100 * 1;
    }

    let l = o.tickInterval || this._linearTickInterval(t, e);
    let c = this._linearNiceDomain(t, e, l);
    if ((t = s ? n : c[0]) >= (e = h ? a : c[1])) {
      e = t + 100 * 1;
    }
    return [t, e];
  };
  formatAxisValue = (str, metricType) => {
    let i = this.props;
    let ext = "";
    let valueFields = i.valueFields || i.metrics;
    if (metricType) {
      BsyUtils.forEach(valueFields, function (a1, a2) {
        if (a2.metricType == metricType) {
          if (a2.format) {
            ext = a2.format;
            return !1;
          }
        }
      });
    } else {
      BsyUtils.forEach(valueFields, function (a1, a2) {
        if (a2.format) {
          ext = a2.format;
          return !1;
        }
      });
    }

    let r = BsyUtils.fixDecimalPrecision(str);
    return BsyUtils.num2Str(r, ext);
  };
  _getDataNiceTicks = (muxtype) => {
    let h = this;
    let _ = this;

    let indMax = 0;
    let indMin = 0;
    if (!muxtype) {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        let tmpmax = Math.max.apply(null, b1);
        if (tmpmax > indMax) indMax = tmpmax;
        let tmpmin = Math.min.apply(null, b1);
        if (tmpmin < indMin) indMin = tmpmin;
      });
    } else {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        if (muxtype === h.metrics[a1].metricType) {
          let tmpmax = Math.max.apply(null, b1);
          if (tmpmax > indMax) indMax = tmpmax;
          let tmpmin = Math.min.apply(null, b1);
          if (tmpmin < indMin) indMin = tmpmin;
        }
      });
    }

    return this.niceTicks(indMin, indMax);
  };
  _getTickLeng = (muxtype) => {
    let h = this;
    let _ = this;

    let indMax = 0;
    let indMin = 0;
    if (!muxtype) {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        let tmpmax = Math.max.apply(null, b1);
        if (tmpmax > indMax) indMax = tmpmax;
        let tmpmin = Math.min.apply(null, b1);
        if (tmpmin < indMin) indMin = tmpmin;
      });
    } else {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        if (muxtype === h.metrics[a1].metricType) {
          let tmpmax = Math.max.apply(null, b1);
          if (tmpmax > indMax) indMax = tmpmax;
          let tmpmin = Math.min.apply(null, b1);
          if (tmpmin < indMin) indMin = tmpmin;
        }
      });
    }
    let minInterval, maxInterval;
    if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
      if (this.newOpthon && this.newOpthon.yAxis) {
        if (muxtype == "right") {
          let mxuindex = 0;
          if (this.newOpthon.yAxis.length == 2) {
            mxuindex = 1;
          }
          if (
            this.newOpthon.yAxis[mxuindex].hasOwnProperty("minInterval") &&
            this.newOpthon.yAxis[mxuindex].minInterval !== null
          )
            minInterval = this.newOpthon.yAxis[mxuindex].minInterval;
          if (
            this.newOpthon.yAxis[mxuindex].hasOwnProperty("maxInterval") &&
            this.newOpthon.yAxis[mxuindex].maxInterval !== null
          )
            maxInterval = this.newOpthon.yAxis[mxuindex].maxInterval;

          if (
            this.newOpthon.yAxis[mxuindex].hasOwnProperty("max") &&
            this.newOpthon.yAxis[mxuindex].max !== null
          )
            indMax = this.newOpthon.yAxis[mxuindex].max;
          if (
            this.newOpthon.yAxis[mxuindex].hasOwnProperty("min") &&
            this.newOpthon.yAxis[mxuindex].min !== null
          )
            indMin = this.newOpthon.yAxis[mxuindex].min;
        } else if (muxtype == "left") {
          if (
            this.newOpthon.yAxis[0].hasOwnProperty("minInterval") &&
            this.newOpthon.yAxis[0].minInterval !== null
          )
            minInterval = this.newOpthon.yAxis[0].minInterval;
          if (
            this.newOpthon.yAxis[0].hasOwnProperty("maxInterval") &&
            this.newOpthon.yAxis[0].maxInterval !== null
          )
            maxInterval = this.newOpthon.yAxis[0].maxInterval;

          if (
            this.newOpthon.yAxis[0].hasOwnProperty("max") &&
            this.newOpthon.yAxis[0].max !== null
          )
            indMax = this.newOpthon.yAxis[0].max;
          if (
            this.newOpthon.yAxis[0].hasOwnProperty("min") &&
            this.newOpthon.yAxis[0].min !== null
          )
            indMin = this.newOpthon.yAxis[0].min;
        } else {
          if (
            this.newOpthon.yAxis.hasOwnProperty("minInterval") &&
            this.newOpthon.yAxis.minInterval !== null
          )
            minInterval = this.newOpthon.yAxis.minInterval;
          if (
            this.newOpthon.yAxis.hasOwnProperty("maxInterval") &&
            this.newOpthon.yAxis.maxInterval !== null
          )
            maxInterval = this.newOpthon.yAxis.maxInterval;

          if (
            this.newOpthon.yAxis.hasOwnProperty("max") &&
            this.newOpthon.yAxis.max !== null
          )
            indMax = this.newOpthon.yAxis.max;
          if (
            this.newOpthon.yAxis.hasOwnProperty("min") &&
            this.newOpthon.yAxis.min !== null
          )
            indMin = this.newOpthon.yAxis.min;
        }
      } else {
        if (
          _.yAxes[0].hasOwnProperty("minInterval") &&
          _.yAxes[0].minInterval !== null
        )
          minInterval = _.yAxes[0].minInterval;
        if (
          _.yAxes[0].hasOwnProperty("maxInterval") &&
          _.yAxes[0].maxInterval !== null
        )
          maxInterval = _.yAxes[0].maxInterval;

        if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
          indMax = _.yAxes[0].max;
        if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null)
          indMin = _.yAxes[0].min;
        if (muxtype == "right") {
          if (
            _.yAxes[1].hasOwnProperty("minInterval") &&
            _.yAxes[1].minInterval !== null
          )
            minInterval = _.yAxes[1].minInterval;
          if (
            _.yAxes[1].hasOwnProperty("maxInterval") &&
            _.yAxes[1].maxInterval !== null
          )
            maxInterval = _.yAxes[1].maxInterval;

          if (_.yAxes[1].hasOwnProperty("max") && _.yAxes[1].max !== null)
            indMax = _.yAxes[1].max;
          if (_.yAxes[1].hasOwnProperty("min") && _.yAxes[1].min !== null)
            indMin = _.yAxes[1].min;
        }
      }
    }

    let nn = this.niceTicks(indMin, indMax, minInterval, maxInterval);
    let ss = 0;
    let t = nn[0],
      e = nn[1],
      l = nn[2];
    for (let index = t; e >= index; ) {
      index = BsyUtils.add(index, l);
      let s1 = index.toString();
      s1 = h.formatAxisValue(s1, muxtype); //生成格式化后的内容

      let s = BsyUtils.getTextPixelWith(s1, {
        fontFamily: "verdana",
        fontSize: 10,
        fontStyle: "normal",
        fontWeight: "normal",
      });
      if (s > ss) {
        ss = s;
      }
    }

    let index = indMin;
    let s1 = index.toString();
    s1 = h.formatAxisValue(s1, muxtype); //生成格式化后的内容

    let s = BsyUtils.getTextPixelWith(s1, {
      fontFamily: "verdana",
      fontSize: 10,
      fontStyle: "normal",
      fontWeight: "normal",
    });
    if (s > ss) {
      ss = s;
    }
    index = indMax;
    s1 = index.toString();
    s1 = h.formatAxisValue(s1, muxtype); //生成格式化后的内容

    s = BsyUtils.getTextPixelWith(s1, {
      fontFamily: "verdana",
      fontSize: 10,
      fontStyle: "normal",
      fontWeight: "normal",
    });
    if (s > ss) {
      ss = s;
    }
    return ss + 5;
  };
  niceTicks = (min, max, minInterval, maxInterval, splitNumber) => {
    splitNumber = splitNumber || 5;
    let extent3 = [min, max];
    let span = extent3[1] - extent3[0];
    if (!isFinite(span)) {
      return;
    }
    if (span < 0) {
      span = -span;
      extent3.reverse();
    }
    let result = this.intervalScaleNiceTicks(
      extent3,
      splitNumber,
      minInterval,
      maxInterval
    );
    result.niceTickExtent.push(result.interval);
    return result.niceTickExtent;
  };
  quantityExponent = (val) => {
    if (val === 0) {
      return 0;
    }
    let exp = Math.floor(Math.log(val) / Math.LN10);
    if (val / Math.pow(10, exp) >= 10) {
      exp++;
    }
    return exp;
  };

  getIntervalPrecision = (interval) => {
    return this.getPrecisionSafe(interval) + 2;
  };

  getPrecisionSafe = (val) => {
    let str = val.toString();
    let eIndex = str.indexOf("e");
    if (eIndex > 0) {
      let precision = +str.slice(eIndex + 1);
      return precision < 0 ? -precision : 0;
    } else {
      let dotIndex = str.indexOf(".");
      return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
    }
  };

  intervalScaleNiceTicks = (extent3, splitNumber, minInterval, maxInterval) => {
    let result = {};
    let span = extent3[1] - extent3[0];

    let interval = (result.interval = this._linearTickInterval(
      extent3[0],
      extent3[1]
    )); //this.nice(span / splitNumber, true);

    if (minInterval != null && interval < minInterval) {
      interval = result.interval = minInterval;
    }
    if (maxInterval != null && interval > maxInterval) {
      interval = result.interval = maxInterval;
    }
    let precision = (result.intervalPrecision =
      this.getIntervalPrecision(interval));
    let niceTickExtent = (result.niceTickExtent = [
      this.roundNumber(Math.floor(extent3[0] / interval) * interval, precision),
      this.roundNumber(Math.ceil(extent3[1] / interval) * interval, precision),
    ]);
    // fixExtent(niceTickExtent, extent3);
    return result;
  };
  getChartData = () => {
    return this.chartUtils
      ? BsyUtils.pick(this.chartUtils, ["series", "category"])
      : {};
  };
  _getColors = () => {
    const { valueFields, chartType } = this.state;
    let t = this.props,
      e = this,
      i = [],
      n = [],
      r = e.palette;

    BsyUtils.forEach(BsyConfig().CONST.DASH_CHART_THEME, function (t, e) {
      if (e.value === r) return (n = e.colors.slice(0)), !1;
    });
    n.length || (n = this.DEFAULT_COLORS);
    switch (chartType) {
      case "column_chart":
      case "bar_chart":
        switch (t.xFields.length) {
          case 1:
            if (valueFields.length > 1) {
              BsyUtils.forEach(valueFields, function (t, r) {
                i.push(e._getFieldColor(r.color, t, n));
              });
            } else {
              let o = {};
              BsyUtils.forEach(t.xFields[0].colors, function (t, e) {
                o[e.value] = e.color;
              });
              let category = this.getChartData().category;
              BsyUtils.forEach(category, function (e, r) {
                let a = o[r];
                if (!a) {
                  a = n[e >= 10 ? e % 10 : e];
                }
                i.push(a);
              });
            }
            break;
          case 2:
            let o = {};
            BsyUtils.forEach(t.xFields[1].colors, function (t, e) {
              o[e.value] = e.color;
            });
            let a = this.getChartData();
            BsyUtils.forEach(a.series, function (t, r) {
              i.push(e._getFieldColor(o[r], t, n));
            });
            break;
          default: {
            break;
          }
        }
        break;
      case "area_chart":
      case "radar_chart":
      case "line_chart":
        switch (t.xFields.length) {
          case 1:
            BsyUtils.forEach(valueFields, function (t, r) {
              i.push(e._getFieldColor(r.color, t, n));
            });
            break;
          case 2:
            let o = {};
            BsyUtils.forEach(t.xFields[1].colors, function (t, e) {
              o[e.value] = e.color;
            });
            let a = this.getChartData();
            BsyUtils.forEach(a.series, function (t, r) {
              i.push(e._getFieldColor(o[r], t, n));
            });
            break;
          default: {
            break;
          }
        }
        break;
      case "pie_chart":
        let o1 = {};
        BsyUtils.forEach(t.xFields[0].colors, function (t, e) {
          o1[e.value] = e.color;
        });
        let series = this.getChartData().series;
        BsyUtils.forEach(series, function (t, r) {
          i.push(e._getFieldColor(o1[r], t, n));
        });
        break;
      case "funnel_chart":
      case "gauge_chart":
        let o2 = {};
        BsyUtils.forEach(t.xFields[0].colors, function (t, e) {
          o2[e.value] = e.color;
        });
        BsyUtils.forEach(this.getChartData().category, function (e, r) {
          let a = o2[r];
          a || (a = n[e >= 10 ? e - 10 : e]);
          i.push(a);
        });
        break;
      case "multi_axes_chart":
        BsyUtils.forEach(valueFields, function (t, r) {
          i.push(e._getFieldColor(r.color, t, n));
        });
        break;
      default: {
        break;
      }
    }
    return i;
  };
  _getFieldColor = (t, e, i) => {
    t || (t = i[e % i.length]);
    return t;
  };

  _linearTickInterval = (t, e, i) => {
    i = i || this._getDefaultTickCount();
    let n = e - t,
      a = Math.pow(10, Math.floor(Math.log(n / i) / Math.LN10)),
      o = (i / n) * a;
    return (
      0.15 >= o ? (a *= 10) : 0.35 >= o ? (a *= 5) : 0.75 >= o && (a *= 2),
      // this.type === r.DATE_AXIS_COMPONENT && (a = Math.max(a, 1e3)),
      a
    );
  };

  _getDefaultTickCount = () => {
    //chartType: "radar_chart"
    return this.state.chartType === "radar_chart" ? 4 : 5;
  };

  roundNumber = (x, precision, returnStr) => {
    if (precision == null) {
      precision = 10;
    }
    precision = Math.min(Math.max(0, precision), 20);
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
  };

  getTick = (muxtype) => {
    let h = this;
    let _ = this;
    let result = [];
    let indMax = 0;
    let indMin = 0;
    if (!muxtype) {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        let tmpmax = Math.max.apply(null, b1);
        if (tmpmax > indMax) indMax = tmpmax;
        let tmpmin = Math.min.apply(null, b1);
        if (tmpmin < indMin) indMin = tmpmin;
      });
    } else {
      BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
        if (muxtype === h.metrics[a1].metricType) {
          let tmpmax = Math.max.apply(null, b1);
          if (tmpmax > indMax) indMax = tmpmax;
          let tmpmin = Math.min.apply(null, b1);
          if (tmpmin < indMin) indMin = tmpmin;
        }
      });
    }
    let minInterval, maxInterval;
    if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
      if (
        _.yAxes[0].hasOwnProperty("minInterval") &&
        _.yAxes[0].minInterval !== null
      )
        minInterval = _.yAxes[0].minInterval;
      if (
        _.yAxes[0].hasOwnProperty("maxInterval") &&
        _.yAxes[0].maxInterval !== null
      )
        maxInterval = _.yAxes[0].maxInterval;

      if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
        indMax = _.yAxes[0].max;
      if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null)
        indMin = _.yAxes[0].min;
      if (muxtype == "right") {
        if (
          _.yAxes[1].hasOwnProperty("minInterval") &&
          _.yAxes[1].minInterval !== null
        )
          minInterval = _.yAxes[1].minInterval;
        if (
          _.yAxes[1].hasOwnProperty("maxInterval") &&
          _.yAxes[1].maxInterval !== null
        )
          maxInterval = _.yAxes[1].maxInterval;

        if (_.yAxes[1].hasOwnProperty("max") && _.yAxes[1].max !== null)
          indMax = _.yAxes[1].max;
        if (_.yAxes[1].hasOwnProperty("min") && _.yAxes[1].min !== null)
          indMin = _.yAxes[1].min;
      }
    }

    let nn = this.niceTicks(indMin, indMax, minInterval, maxInterval);

    let t = nn[0],
      e = nn[1],
      l = nn[2];
    for (let index = t; e >= index; ) {
      index = BsyUtils.add(index, l);
      let s1 = index.toString();
      s1 = h.formatAxisValue(s1, muxtype); //生成格式化后的内容
      result.push(s1);
    }
    return result;
  };
  //重新图表的属性，因为以前的一老历史逻辑遗留问题，后续逐步梳理
  _labelformatter = (s, seriesdata) => {
    let _ = this;
    if (_.readorgval) {
      return _._formatValue(
        seriesdata[s.seriesIndex][s.dataIndex],
        s.seriesIndex
      );
    } else {
      return _._formatValue(s.data.value, s.seriesIndex);
    }
  };
  //计算 label的边缘
  rectangleOverlapped = (t, e) => {
    if (!t || !e) return !1;
    let i = Math.max(t.x, e.x),
      n = Math.max(t.y, e.y),
      r = Math.min(t.x + t.width, e.x + e.width),
      a = Math.min(t.y + t.height, e.y + e.height);
    return r >= i && a >= n;
  };
  //
  isOverlapped = (t, labelLayout, key, retout) => {
    let _ = this;
    let res = false;
    BsyUtils.forEach(labelLayout, (a1, b1) => {
      if (a1 == key) {
        return !0;
      }
      if (!BsyUtils.isObjectEmpty(b1)) {
        if (b1.hasOwnProperty("show")) {
          if (b1.show == false) return !0;
        }

        if (_.rectangleOverlapped(t, b1)) {
          // retout = labelLayout[e][j];
          // height: 26
          // width: 43.41796875
          // x: 91.7280767299107
          // y: 152.09418181818182
          retout.x = b1.x;
          retout.y = b1.y;
          retout.width = b1.width;
          retout.height = b1.height;
          res = !0;
        }
      }
    });
    return res;
  };

  _getLegendHeight = (Legend, elwdith, fontStyle) => {
    let _ = this;
    let category = "";
    let c = 0; // 图例会有几行
    let tmpwid = 0;
    let height = parseInt(fontStyle.fontSize) || 10;

    if (_.attrList.legend.type == "scroll") {
      return height + 10;
    }

    BsyUtils.forEach(Legend, (a1, b1) => {
      let tmpwidth = BsyUtils.getTextPixelWith(
        b1,
        fontStyle || {
          fontFamily: "verdana",
          fontSize: 10,
          fontStyle: "normal",
          fontWeight: "normal",
        }
      );
      tmpwid += tmpwidth + 10 + 14 + 5;
      if (tmpwid > elwdith) {
        c++;
        tmpwid = tmpwidth + 10 + 14 + 5;
      }
    });
    return (c + 1) * (height + 10);
  };
  _getLabelKey = (x, y) => {
    return Math.floor(x * 1000000 + y);
  };
  //计算 图例占的宽度
  _getLegendLeng = (Legend, fontStyle, bodyHeight) => {
    let _ = this;
    let allWidth = 0;

    let tmplineHeight = 0;
    let fontHeight = parseInt(fontStyle.fontSize || 10);
    let tmpLegend = [];
    //带分页模式 只需要计算一列的宽度
    if (_.attrList.legend.type != "scroll") {
      BsyUtils.forEach(Legend, (a1, b1) => {
        if (!b1) {
          return !0;
        }

        tmplineHeight += fontHeight + 10;
        // console.log(tmplineHeight,b1);
        if (tmplineHeight >= bodyHeight) {
          tmpLegend.push(b1);
          let ss = 0;
          BsyUtils.forEach(tmpLegend, (a2, b2) => {
            let s = BsyUtils.getTextPixelWith(b2, fontStyle, {
              fontFamily: "verdana",
              fontSize: 10,
              fontStyle: "normal",
              fontWeight: "normal",
            });
            if (s > ss) {
              ss = s;
            }
          });
          allWidth += ss + 34;
          tmplineHeight = 0;
          tmpLegend = [];
        } else {
          tmpLegend.push(b1);
        }
      });
    } else {
      tmpLegend = Legend;
    }

    // if(allWidth == 0)

    let ss = 0;
    BsyUtils.forEach(tmpLegend, (a2, b2) => {
      let s = BsyUtils.getTextPixelWith(b2, fontStyle, {
        fontFamily: "verdana",
        fontSize: 10,
        fontStyle: "normal",
        fontWeight: "normal",
      });
      if (s > ss) {
        ss = s;
      }
    });
    allWidth += ss;

    return allWidth;
  };
  //检测Y轴间隔
  _checkInterval = () => {
    let sliptNumber = 100; // y轴刻度，最多300个 ，超过了就会卡
    let _ = this;
    const { chartType } = this.state;
    let opt = this.props;
    let h = this;
    let indMax = 0;
    let indMin = 0;
    // if(!muxtype)
    // {
    let markLine = _._addThresholdLine();
    let markLineValue = _.niceTicks(markLine.min, markLine.max);
    BsyUtils.forEach(h.chartUtils.data, (a1, b1) => {
      if (chartType === "area_chart") {
        let tmpmax = Math.max.apply(null, b1);
        indMax += tmpmax;
        let tmpmin = Math.min.apply(null, b1);
        indMin += tmpmin;
      } else {
        let tmpmax = Math.max.apply(null, b1);
        if (tmpmax > indMax) indMax = tmpmax;
        let tmpmin = Math.min.apply(null, b1);
        if (tmpmin < indMin) indMin = tmpmin;
      }
    });

    if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
      if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null) {
        indMax = _.yAxes[0].max;
        if (markLine.max > indMax) {
          indMax = markLineValue[1];
        }
      } else {
        if (markLine.max > indMax) {
          indMax = markLineValue[1];
        }
      }
      if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null) {
        indMin = _.yAxes[0].min;
        if (markLine.min < indMin) {
          indMin = markLineValue[0];
        }
      } else {
        if (markLine.min < indMin) {
          indMin = markLineValue[0];
        }
      }

      if (indMax < 0 && indMin < 0) {
        let d = [Math.abs(indMin), Math.abs(indMax)];
        //Math.max.apply(null, b1);
        let min = Math.min.apply(null, d);
        let max = Math.max.apply(null, d);

        indMax = max;
        indMin = min;
      }
      let nn = (indMax - indMin) / sliptNumber;
      if (
        _.yAxes[0].hasOwnProperty("maxInterval") &&
        _.yAxes[0].maxInterval !== null
      ) {
        if (_.yAxes[0].maxInterval < nn) {
          _.yAxes[0].maxInterval = undefined;
        }
      }
    }
  };
  _hasDimension = () => {
    return this.props.xFields.length > 0;
  };
  _formatValue = (t, e, h, f) => {
    const { valueFields } = this.state;
    BsyUtils.isObjectEmpty(valueFields) || 1 !== valueFields.length || (e = 0);
    // let n = valueFields[e] && valueFields[e].format
    //     , r = BsyUtils.fixDecimalPrecision(t);
    // return BsyUtils.num2Str(r, n)

    // let res = BsyUtils.numberFormatValue(t,valueFields[e] )
    // return res.text
    let res = {
      value: "",
      text: "",
    };
    if (
      ["flow_assist.assist_protime", "flow_assist.assist_outtime"].includes(
        valueFields[e].name
      )
    ) {
      res = BsyUtils.numberFormatTime(t, valueFields[e]);
    } else {
      res = BsyUtils.numberFormatValue(t, valueFields[e]);
      const afterSuffixVal = getAfterSuffix(valueFields[e].afterSuffix)
      if (afterSuffixVal && res.text && !res.text.includes("%")) {
          res.text = res.text + " " + afterSuffixVal;
      }
    }

    return res.text;
  };
  _renderBarGrid = (legenddata, xAxisData, seriesdata) => {
    let _ = this;
    let opt = this.props;
    _._getDataNiceTicks();
    //默认边距
    let grid = {
      top: _.top_offset,
      right: _.right_offset,
      bottom: _.botton_offset - 10,
      left: _.left_offset,
    };

    //计算刻度占比
    let legendWidth = 0;
    let legendHeight = 0;
    let ytitleWidth = 0;
    //轴标题，占10
    if (
      _.yAxes.length > 0 &&
      _.yAxes[0].hasOwnProperty("title") &&
      _.yAxes[0].title &&
      _.yAxes[0].title.text
    ) {
      ytitleWidth = 30;
      grid.top += ytitleWidth;
    }

    grid.left += _._getAxisDataLeng();

    //图例的占高宽
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        grid.left += legendWidth;
      } else if (opt.legend.position === "right") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        grid.right += legendWidth;
      } else if (opt.legend.position === "top") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        grid.top += legendHeight;
      } else if (opt.legend.position === "bottom") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        grid.bottom += legendHeight;
      } else {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        grid.bottom += legendHeight;
      }
    }

    return grid;
  };
  _renderGrid = (legenddata, xAxisData, seriesdata) => {
    let _ = this;
    let opt = this.props;

    //默认边距
    let grid = {
      top: _.top_offset,
      right: _.right_offset,
      bottom: _.botton_offset,
      left: _.left_offset,
    };

    switch (this.state.chartType) {
      case "multi_axes_chart": {
        let leftA = false;
        let rightA = false;
        BsyUtils.forEach(_.metrics, (a1, b1) => {
          if (b1.metricType == "left") {
            leftA = true;
          } else if (b1.metricType == "right") {
            rightA = true;
          }
        });
        if (leftA) {
          grid.left += _._getTickLeng("left");
          let ytitleWidth = 0;
          //轴标题，占10
          if (
            _.yAxes.length > 0 &&
            _.yAxes[0].hasOwnProperty("title") &&
            _.yAxes[0].title &&
            _.yAxes[0].title.text
          ) {
            ytitleWidth = 10;
            grid.left += ytitleWidth;
          }
        }
        if (rightA) {
          grid.right += _._getTickLeng("right");
          let ytitleWidth = 0;
          //轴标题，占10
          if (
            _.yAxes.length > 0 &&
            _.yAxes[1].hasOwnProperty("title") &&
            _.yAxes[1].title &&
            _.yAxes[1].title.text
          ) {
            ytitleWidth = 10;
            grid.right += ytitleWidth;
          }
        }
        if (this.props.xAxis.hasOwnProperty("label")) {
          switch (
            this.props.xAxis.label.rotation //标签文字显示方向
          ) {
            case 90: {
              //竖
              let axisHeight = _._getAxisDataLeng();
              if (axisHeight < _.botton_offset) {
                //保证最小x刻度的占高
                axisHeight = _.botton_offset;
              }

              grid.bottom += axisHeight - _.rotation_botton_offse;
              break;
            }
            case 25: //左斜
            case -25: {
              //右斜
              //  c ----------  b
              //    |        /
              //    |       /
              //    |      /
              //    |     /
              //    |    /
              //    |   /
              //    |  /
              //    | /
              //    |/  a 25度
              //  axisHeight(bc) = _._getAxisDataLeng() * Math.sin (25* Math.PI / 180) ;

              let axisHeight =
                _._getAxisDataLeng() * Math.sin((25 * Math.PI) / 180);
              if (axisHeight < _.botton_offset) {
                //保证最小x刻度的占高
                axisHeight = _.botton_offset;
              }
              // console.log("右斜,左斜",axisHeight)
              grid.bottom += axisHeight - 10;
              break;
            }
            default: {
              break;
            }
          }
          if (this.props.xAxis.label.step) {
            //强制显示所有
            grid = {
              containLabel: this.props.xAxis.label.step,
            };
          }
        }
        break;
      }

      default: {
        grid.left += _._getTickLeng();
        let ytitleWidth = 0;
        //轴标题，占10
        if (
          _.yAxes.length > 0 &&
          _.yAxes[0].hasOwnProperty("title") &&
          _.yAxes[0].title &&
          _.yAxes[0].title.text
        ) {
          ytitleWidth = 10;
          grid.left += ytitleWidth;
        }
        if (this.props.xAxis.hasOwnProperty("label")) {
          switch (
            this.props.xAxis.label.rotation //标签文字显示方向
          ) {
            case 90: {
              //竖
              let axisHeight = _._getAxisDataLeng();
              if (axisHeight < _.botton_offset) {
                //保证最小x刻度的占高
                axisHeight = _.botton_offset;
              }
              // console.log("竖",axisHeight)

              grid.bottom += axisHeight - _.rotation_botton_offse;
              break;
            }
            case 25: //左斜
            case -25: {
              //右斜
              //  c ----------  b
              //    |        /
              //    |       /
              //    |      /
              //    |     /
              //    |    /
              //    |   /
              //    |  /
              //    | /
              //    |/  a 25度
              //  axisHeight(bc) = _._getAxisDataLeng() * Math.sin (25* Math.PI / 180) ;

              let axisHeight =
                _._getAxisDataLeng() * Math.sin((25 * Math.PI) / 180);
              if (axisHeight < _.botton_offset) {
                //保证最小x刻度的占高
                axisHeight = _.botton_offset;
              }
              // console.log("右斜,左斜",axisHeight)
              grid.bottom += axisHeight - 10;
              break;
            }
            default: {
              break;
            }
          }
          if (this.props.xAxis.label.step) {
            //强制显示所有
            grid = {
              containLabel: this.props.xAxis.label.step,
            };
          }
        }
      }
    }

    if (!grid.hasOwnProperty("containLabel")) {
      //计算刻度占比
      let legendWidth = 0;
      let legendHeight = 0;
      //图例的占高宽
      if (opt.legend && opt.legend.enable) {
        if (opt.legend.position === "left") {
          legendWidth =
            _._getLegendLeng(
              legenddata,
              _.attrList.legend.textStyle,
              this.echartsRef.current.offsetHeight -
                _.top_offset -
                _.botton_offset
            ) + 25; //要考虑文字 跟小圆点的距离
          grid.left += legendWidth;
        } else if (opt.legend.position === "right") {
          legendWidth =
            _._getLegendLeng(
              legenddata,
              _.attrList.legend.textStyle,
              this.echartsRef.current.offsetHeight -
                _.top_offset -
                _.botton_offset
            ) + 25; //要考虑文字 跟小圆点的距离
          grid.right += legendWidth;
        } else if (opt.legend.position === "top") {
          legendHeight = _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          );
          grid.top += legendHeight;
        } else if (opt.legend.position === "bottom") {
          legendHeight = _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          );
          grid.bottom += legendHeight;
        } else {
          legendHeight = _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          );
          grid.bottom += legendHeight;
        }
      }
    }

    // console.log(grid)
    return grid;
  };
  //根据属性重新计算极坐标半径
  _renderRadius = (props, legenddata) => {
    let _ = this;
    let opt = this.props;
    let center = props.radar.center;
    let nameGap = props.radar.nameGap;
    let legendHeight = 0;
    let legendWidth = 0;
    let cyoffset = 0;
    let cxoffset = 0;

    //可显示范围
    let bodyRect = {
      x: 0,
      y: 0,
      x1: this.echartsRef.current.offsetWidth - 20,
      y1: this.echartsRef.current.offsetHeight - 20,
    };

    //先计算多出来的空间
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        bodyRect.x1 -= legendWidth + 20;
      } else if (opt.legend.position === "right") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        bodyRect.x1 -= legendWidth + 20;
      } else if (opt.legend.position === "top") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      } else if (opt.legend.position === "bottom") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      } else {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      }
    }

    let bodyWidth = bodyRect.x1 - bodyRect.x;
    let bodyHeight = bodyRect.y1 - bodyRect.y;

    let cx = BsyUtils.parsePercent2(center[0], bodyWidth);
    let cy = BsyUtils.parsePercent2(center[1], bodyHeight);
    let r2 = Math.min(bodyWidth, bodyHeight) - nameGap * 2; //20 预留边框

    let r = r2 / 2;
    if (r <= 10) {
      //最小刻度
      r = 10;
    }
    let _indicatorAxes = props.radar.indicator;

    // BsyUtils._renderPointClear();
    // BsyUtils._renderPoint({
    //     left:cx+$(".component-content").offset().left,
    //     top:cy+$(".component-content").offset().top,
    // })

    //预测半径
    //r 半径值
    //diameter 允许超出的范围
    let prediction = (r, overlapping) => {
      let result = true;
      // console.log("半径：" + r);

      BsyUtils.forEach(_indicatorAxes, (idx, b1) => {
        // 360 - 角度 是为了与 echarts坐标达到一致
        let radian = (360 / _indicatorAxes.length) * idx;
        let angle = ((360 - radian) * Math.PI) / 180;
        let x = Math.sin(angle) * r;
        let y = Math.cos(angle) * r;

        let obj = {
          cx: cx,
          cy: cy,
          name: b1.name,
        };

        obj.x = cx + x;
        obj.y = cy - y;

        // console.log(b1.name+":" + JSON.stringify(obj));

        //字体大小为10
        let nameWidth = BsyUtils.getTextPixelWith(b1.name, {
          fontFamily: "verdana",
          fontSize: 10,
          fontStyle: "normal",
          fontWeight: "normal",
        });
        let nameHeight = 10;
        // console.log(b1.name+"宽:" + nameWidth);
        let xs = BsyUtils.getAnglePos(360 - radian);
        let key = "ss-" + (360 - radian) + "-" + obj.name;

        if (overlapping) {
          if (!showLables.hasOwnProperty(key)) {
            showLables[key] = {
              x: obj.x,
              y: obj.y,
              width: nameWidth,
              height: 10,
              show: !0,
            };
            let outRect = {};
            if (_.isOverlapped(showLables[key], showLables, key, outRect)) {
              showLables[key].show = false;
              secondPrediction = true;
              // console.log(obj);
            }
          }
        }
        //忽略这个元素
        if (showLables.hasOwnProperty(key) && !showLables[key].show) {
          return !0;
        }

        switch (xs) {
          case "top": {
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            break;
          }
          case "righttop":
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            break;

          case "right": {
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            break;
          }
          case "rightbottom": {
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            break;
          }
          case "bottom": {
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            break;
          }
          case "leftbottom": {
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          case "left": {
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          case "lefttop": {
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          default: {
            break;
          }
        }

        // console.log(xs+" "+b1.name+":" + JSON.stringify(obj));

        // //界面上画点 测试使用
        // let pos = {
        //     x:obj.x,
        //     y:obj.y
        // };

        // BsyUtils._renderPoint({
        //     left:pos.x,
        //     top:pos.y,
        // })
        //界面上画点 测试使用
      });
      return result;
    };
    //记录需要显示标签，用于二次预测使用
    let showLables = {};
    let secondPrediction = false;

    let lastR = r;
    while (1) {
      if (prediction(r)) {
        prediction(r, true);
        break;
      }
      showLables = {};
      secondPrediction = false;
      lastR = r;
      r = r - 10;
      if (r <= 10) {
        //最小刻度
        r = 10;
        prediction(r, true);
        break;
      }
      // break;
    }
    //第二次辅助修复
    if (secondPrediction) {
      r = r2 / 2;
      lastR = r;
      while (1) {
        if (prediction(r)) {
          break;
        }
        lastR = r;
        r = r - 10;
        if (r <= 10) {
          //最小刻度
          r = 10;
          break;
        }
        // break;
      }
    }

    //根据方向重新修正偏移
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        // legendWidth = _._getLegendLeng(legenddata,_.attrList.legend.textStyle,this.echartsRef.current.offsetHeight  - _.top_offset - _.botton_offset ) + 25 //要考虑文字 跟小圆点的距离
        // bodyRect.x1 -= (legendWidth + 20);

        let offset = this.echartsRef.current.offsetWidth - bodyRect.x1; //计算多余空间
        cxoffset = legendWidth;
      } else if (opt.legend.position === "right") {
        // legendWidth = _._getLegendLeng(legenddata,_.attrList.legend.textStyle,this.echartsRef.current.offsetHeight  - _.top_offset - _.botton_offset ) + 25 //要考虑文字 跟小圆点的距离
        // bodyRect.x1 -= (legendWidth + 20);

        let offset =
          this.echartsRef.current.offsetWidth - bodyRect.x1 - legendWidth; //计算多余空间
        cxoffset = offset / 2;
      } else if (opt.legend.position === "top") {
        // legendHeight = _._getLegendHeight(legenddata,this.echartsRef.current.offsetWidth,_.attrList.legend.textStyle);
        // bodyRect.y1 -= (legendHeight + 20);

        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = legendHeight + offset / 2;
      } else if (opt.legend.position === "bottom") {
        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = offset / 2;
      } else {
        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = offset / 2;
      }
    } else {
      props.radar.radius = "80%";
      props.radar.center[0] = "50%";
      props.radar.center[1] = "50%";
      return;
    }

    props.radar.radius = r;
    props.radar.center[0] = cx + cxoffset;
    props.radar.center[1] = cy + cyoffset;
  };
  //根据属性重新计算极坐标半径
  _renderPolar = (props, legenddata) => {
    let _ = this;
    let opt = this.props;
    let center = ["50%", "50%"];
    let nameGap = 20; //props.polar.nameGap;
    let legendHeight = 0;
    let legendWidth = 0;
    let cyoffset = 0;
    let cxoffset = 0;

    //可显示范围
    let bodyRect = {
      x: 0,
      y: 0,
      x1: this.echartsRef.current.offsetWidth - 40,
      y1: this.echartsRef.current.offsetHeight - 20,
    };

    //先计算多出来的空间
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        bodyRect.x1 -= legendWidth + 20;
      } else if (opt.legend.position === "right") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25; //要考虑文字 跟小圆点的距离
        bodyRect.x1 -= legendWidth + 20;
      } else if (opt.legend.position === "top") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      } else if (opt.legend.position === "bottom") {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      } else {
        legendHeight = _._getLegendHeight(
          legenddata,
          this.echartsRef.current.offsetWidth,
          _.attrList.legend.textStyle
        );
        bodyRect.y1 -= legendHeight + 20;
      }
    }

    let bodyWidth = bodyRect.x1 - bodyRect.x;
    let bodyHeight = bodyRect.y1 - bodyRect.y;

    let cx = BsyUtils.parsePercent2(center[0], bodyWidth);
    let cy = BsyUtils.parsePercent2(center[1], bodyHeight);
    let r2 = Math.min(bodyWidth, bodyHeight) - nameGap * 2; //20 预留边框

    let r = r2 / 2;
    if (r <= 10) {
      //最小刻度
      r = 10;
    }
    let _indicatorAxes = [];

    if (props.radiusAxis.type == "value") {
      _indicatorAxes = props.radiusAxis.data;
    } else {
      _indicatorAxes = _.getTick();
    }

    // BsyUtils._renderPointClear();
    // BsyUtils._renderPoint({
    //     left:cx+$(".component-content").offset().left,
    //     top:cy+$(".component-content").offset().top,
    // })

    //预测半径
    //r 半径值
    //diameter 允许超出的范围
    let prediction = (r, overlapping) => {
      let result = true;
      // console.log("半径：" + r);

      BsyUtils.forEach(_indicatorAxes, (idx, b1) => {
        // 360 - 角度 是为了与 echarts坐标达到一致
        let radian = (360 / _indicatorAxes.length) * idx;
        let radianNext = (360 / _indicatorAxes.length) * (idx + 1);
        let bradian = radian + (radianNext - radian) / 2;
        let angle = (radian * Math.PI) / 180;
        let x = Math.sin(angle) * r;
        let y = Math.cos(angle) * r;

        let obj = {
          cx: cx,
          cy: cy,
          name: b1,
        };

        obj.x = cx + x;
        obj.y = cy - y;

        // console.log(b1.name+":" + JSON.stringify(obj));

        //字体大小为10
        let nameWidth = BsyUtils.getTextPixelWith(b1, {
          fontFamily: "verdana",
          fontSize: 10,
          fontStyle: "normal",
          fontWeight: "normal",
        });
        let nameHeight = 10;
        // console.log(b1.name+"宽:" + nameWidth);
        let xs = BsyUtils.getAnglePos(radian);
        let key = "ss-" + radian + "-" + obj.name;

        if (overlapping) {
          if (!showLables.hasOwnProperty(key)) {
            showLables[key] = {
              x: obj.x,
              y: obj.y,
              width: nameWidth,
              height: 10,
              show: !0,
            };
            let outRect = {};
            if (_.isOverlapped(showLables[key], showLables, key, outRect)) {
              showLables[key].show = false;
              secondPrediction = true;
              // console.log(obj);
            }
          }
        }
        //忽略这个元素
        if (showLables.hasOwnProperty(key) && !showLables[key].show) {
          return !0;
        }

        switch (xs) {
          case "top": {
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            break;
          }
          case "righttop":
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            break;

          case "right": {
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            break;
          }
          case "rightbottom": {
            obj.x += nameWidth;
            if (obj.x >= bodyRect.x1) {
              result = false;
              return !1;
            }
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            break;
          }
          case "bottom": {
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            break;
          }
          case "leftbottom": {
            obj.y += nameHeight;
            if (obj.y >= bodyRect.y1) {
              result = false;
              return !1;
            }
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          case "left": {
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          case "lefttop": {
            obj.y -= nameHeight;
            if (obj.y <= bodyRect.y) {
              result = false;
              return !1;
            }
            obj.x -= nameWidth;
            if (obj.x <= bodyRect.x) {
              result = false;
              return !1;
            }
            break;
          }
          default: {
            break;
          }
        }

        // console.log(xs+" "+b1.name+":" + JSON.stringify(obj));

        //界面上画点 测试使用
        // let pos = {
        //     x:obj.x,
        //     y:obj.y
        // };

        // BsyUtils._renderPoint({
        //     left:pos.x+$(".component-content").offset().left,
        //     top:pos.y+$(".component-content").offset().top,
        // })
        //界面上画点 测试使用
      });
      return result;
    };

    //记录需要显示标签，用于二次预测使用
    let showLables = {};
    let secondPrediction = false;

    let lastR = r;
    while (1) {
      if (prediction(r)) {
        prediction(r, true);
        break;
      }
      showLables = {};
      secondPrediction = false;
      lastR = r;
      r = r - 10;
      if (r <= 10) {
        //最小刻度
        r = 10;
        prediction(r, true);
        break;
      }
      // break;
    }
    //第二次辅助修复
    if (secondPrediction) {
      r = r2 / 2;
      lastR = r;
      while (1) {
        if (prediction(r)) {
          break;
        }
        lastR = r;
        r = r - 10;
        if (r <= 10) {
          //最小刻度
          r = 10;
          break;
        }
        // break;
      }
    }

    //根据方向重新修正偏移
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        // legendWidth = _._getLegendLeng(legenddata,_.attrList.legend.textStyle,this.echartsRef.current.offsetHeight  - _.top_offset - _.botton_offset ) + 25 //要考虑文字 跟小圆点的距离
        // bodyRect.x1 -= (legendWidth + 20);

        let offset = this.echartsRef.current.offsetWidth - bodyRect.x1; //计算多余空间
        cxoffset = legendWidth + 40; //40   边距人宽度
      } else if (opt.legend.position === "right") {
        // legendWidth = _._getLegendLeng(legenddata,_.attrList.legend.textStyle,this.echartsRef.current.offsetHeight  - _.top_offset - _.botton_offset ) + 25 //要考虑文字 跟小圆点的距离
        // bodyRect.x1 -= (legendWidth + 20);

        let offset =
          this.echartsRef.current.offsetWidth - bodyRect.x1 - legendWidth; //计算多余空间
        cxoffset = offset / 2 - 20; //边距的一半
      } else if (opt.legend.position === "top") {
        // legendHeight = _._getLegendHeight(legenddata,this.echartsRef.current.offsetWidth,_.attrList.legend.textStyle);
        // bodyRect.y1 -= (legendHeight + 20);

        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = legendHeight + offset / 2;
        cxoffset = 20;
      } else if (opt.legend.position === "bottom") {
        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = offset / 2;
        cxoffset = 20;
      } else {
        let offset =
          this.echartsRef.current.offsetHeight - bodyRect.y1 - legendHeight; //计算多余空间
        cyoffset = offset / 2;
        cxoffset = 20;
      }
    } else {
      props.polar.radius = "80%";
      props.polar.center[0] = "50%";
      props.polar.center[1] = "50%";
      return;
    }
    props.polar.radius = r;
    props.polar.center[0] = cx + cxoffset;
    props.polar.center[1] = cy + cyoffset;
  };

  //根据属性重新计算饼图半径
  _renderPie = (legenddata) => {
    let _ = this;
    let opt = this.props;
    let result = {
      center: ["50%", "50%"],
      radius: "50%",
    };

    let caleSize = 1;

    //饼图 顶与底 可用偏移为 60
    let offset = 30;
    let legendHeight = 0;
    let legendWidth = 0;
    //先计算多出来的空间
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25;

        let bodyWidth = this.echartsRef.current.offsetWidth - legendWidth;
        let bodyHeight =
          Math.min(this.echartsRef.current.offsetHeight, bodyWidth) -
          offset * 2;
        result.radius = (bodyHeight / 2) * caleSize;
        result.center[0] = legendWidth + bodyWidth / 2;
      } else if (opt.legend.position === "right") {
        legendWidth =
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25;

        let bodyWidth = this.echartsRef.current.offsetWidth - legendWidth;
        let bodyHeight =
          Math.min(this.echartsRef.current.offsetHeight, bodyWidth) -
          offset * 2;
        result.radius = (bodyHeight / 2) * caleSize;

        result.center[0] = bodyWidth / 2;
      } else if (opt.legend.position === "top") {
        legendHeight =
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
        let bodyHeight =
          this.echartsRef.current.offsetHeight - legendHeight - offset * 2;

        bodyHeight =
          Math.min(
            this.echartsRef.current.offsetHeight - legendHeight,
            this.echartsRef.current.offsetWidth
          ) -
          offset * 2;

        result.radius = (bodyHeight / 2) * caleSize;

        if (
          this.echartsRef.current.offsetHeight - legendHeight >
          this.echartsRef.current.offsetWidth
        ) {
          result.center[1] = offset + this.echartsRef.current.offsetHeight / 2;
        } else {
          result.center[1] = offset + result.radius + legendHeight;
        }
      } else if (opt.legend.position === "bottom") {
        legendHeight =
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
        let bodyHeight =
          Math.min(
            this.echartsRef.current.offsetHeight - legendHeight,
            this.echartsRef.current.offsetWidth
          ) -
          offset * 2;
        result.radius = (bodyHeight / 2) * caleSize;

        if (
          this.echartsRef.current.offsetHeight - legendHeight >
          this.echartsRef.current.offsetWidth
        ) {
          result.center[1] =
            offset + (this.echartsRef.current.offsetHeight - legendHeight) / 2;
        } else {
          result.center[1] = offset + result.radius;
        }
      } else {
        legendHeight =
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
        let bodyHeight =
          Math.min(
            this.echartsRef.current.offsetHeight - legendHeight,
            this.echartsRef.current.offsetWidth
          ) -
          offset * 2;
        result.radius = (bodyHeight / 2) * caleSize;
        if (
          this.echartsRef.current.offsetHeight - legendHeight >
          this.echartsRef.current.offsetWidth
        ) {
          result.center[1] =
            offset + (this.echartsRef.current.offsetHeight - legendHeight) / 2;
        } else {
          result.center[1] = offset + result.radius;
        }
      }
    } else {
      if (!opt.chart_label || !opt.chart_label.enable) {
        result.radius = "80%";
      } else {
        result.radius = "65%";
      }
    }

    return result;
  };
  _renderFunnel = (legenddata) => {
    let _ = this;
    let opt = this.props;

    //默认边距
    let grid = {
      top: _.top_offset,
      right: _.right_offset,
      bottom: _.botton_offset,
      left: _.left_offset,
    };

    //先计算多出来的空间
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        grid.left +=
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25;
      } else if (opt.legend.position === "right") {
        grid.right +=
          _._getLegendLeng(
            legenddata,
            _.attrList.legend.textStyle,
            this.echartsRef.current.offsetHeight -
              _.top_offset -
              _.botton_offset
          ) + 25;
      } else if (opt.legend.position === "top") {
        grid.top +=
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
      } else if (opt.legend.position === "bottom") {
        grid.bottom +=
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
      } else {
        grid.bottom +=
          _._getLegendHeight(
            legenddata,
            this.echartsRef.current.offsetWidth,
            _.attrList.legend.textStyle
          ) + 10;
      }
    }

    return grid;
  };

  _renderOptions = (option, legenddata, xAxisData, seriesdata) => {
    if (!seriesdata || seriesdata.length == 0) {
      return null;
    }

    let _ = this;

    let opt = this.props;

    this.yAxes = JSON.parse(JSON.stringify(opt.yAxes));

    _._checkInterval();
    let newOpthon = (this.newOpthon = {
      color: this._getColors(),
      grid: {
        top: _.top_offset,
        right: _.right_offset,
        bottom: _.botton_offset,
        left: _.left_offset + _._getTickLeng(),
      },
    });
    if (BsyUtils.isString(_.attrList.label.fontSize)) {
      _.attrList.label.fontSize = parseInt(_.attrList.label.fontSize);
    }

    let legend = {
      ...{},
      ...this.attrList.legend,
      ...{
        data: legenddata,
        show: !opt.legend ? false : opt.legend.enable,
        position: null,
        itemWidth: 12,
        itemHeight: 12,
        top: "bottom",
        left: "center",
        orient: "horizontal",
        pageIconColor: _.textColor,
        pageTextStyle: {
          color: _.textColor,
        },
      },
    };

    let shangxiacustomTag = [
      "M7.99 15.01c-0.94 0-1.86-0.19-2.73-0.55-0.83-0.35-1.58-0.86-2.22-1.5-0.64-0.64-1.15-1.39-1.5-2.22-0.36-0.86-0.55-1.78-0.55-2.73 0-0.94 0.19-1.86 0.55-2.72 0.35-0.83 0.86-1.58 1.5-2.23 0.64-0.64 1.39-1.15 2.22-1.49 0.86-0.36 1.78-0.55 2.73-0.56 0.94 0 1.86 0.19 2.72 0.56 0.83 0.35 1.58 0.86 2.22 1.49 0.64 0.64 1.15 1.39 1.5 2.23 0.36 0.86 0.55 1.78 0.55 2.72 0 0.94-0.19 1.86-0.55 2.73-0.35 0.83-0.86 1.58-1.5 2.22-0.64 0.64-1.39 1.15-2.22 1.5-0.86 0.36-1.78 0.55-2.72 0.55z m0-13c-3.31 0-6 2.69-6 6 0 3.31 2.69 6 6 6 3.31 0 6-2.69 5.99-6 0-3.31-2.69-6-5.99-6z M11.35 9.91c-0.19 0.2-0.51 0.2-0.71 0l-2.83-2.76-2.51 2.75c-0.19 0.2-0.5 0.22-0.7 0.03-0.11-0.1-0.16-0.23-0.16-0.37 0-0.12 0.05-0.24 0.13-0.34l2.84-3.12c0.19-0.2 0.5-0.22 0.71-0.03 0.03 0.03 0.06 0.06 0.08 0.09 0.04 0.02 0.08 0.05 0.12 0.09l3.02 2.95c0.2 0.19 0.2 0.51 0.01 0.71z ",
      "M7.99 15.01c-0.94 0-1.86-0.19-2.73-0.55-0.83-0.35-1.58-0.86-2.22-1.5-0.64-0.64-1.15-1.39-1.5-2.22-0.36-0.86-0.55-1.78-0.55-2.73 0-0.94 0.19-1.86 0.55-2.72 0.35-0.83 0.86-1.58 1.5-2.23 0.64-0.64 1.39-1.15 2.22-1.49 0.86-0.36 1.78-0.55 2.73-0.56 0.94 0 1.86 0.19 2.72 0.56 0.83 0.35 1.58 0.86 2.22 1.49 0.64 0.64 1.15 1.39 1.5 2.23 0.36 0.86 0.55 1.78 0.55 2.72 0 0.94-0.19 1.86-0.55 2.73-0.35 0.83-0.86 1.58-1.5 2.22-0.64 0.64-1.39 1.15-2.22 1.5-0.86 0.36-1.78 0.55-2.72 0.55z m0-13c-3.31 0-6 2.69-6 6 0 3.31 2.69 6 6 6 3.31 0 6-2.69 5.99-6 0-3.31-2.69-6-5.99-6z M11.35 6.09c-0.19-0.2-0.51-0.2-0.71-0.01l-2.83 2.77-2.51-2.75c-0.19-0.2-0.5-0.22-0.7-0.03-0.11 0.1-0.16 0.23-0.16 0.37 0 0.12 0.05 0.24 0.13 0.33l2.84 3.13c0.19 0.2 0.5 0.22 0.71 0.03 0.03-0.03 0.06-0.06 0.08-0.1 0.04-0.02 0.08-0.05 0.12-0.08l3.02-2.95c0.2-0.19 0.2-0.51 0.01-0.71z ",
    ];
    let zuoyoucustomTag = [
      "M7.99 15.01c-0.94 0-1.86-0.19-2.73-0.55-0.83-0.35-1.58-0.86-2.22-1.5-0.64-0.64-1.15-1.39-1.5-2.22-0.36-0.86-0.55-1.78-0.55-2.73 0-0.94 0.19-1.86 0.55-2.72 0.35-0.83 0.86-1.58 1.5-2.23 0.64-0.64 1.39-1.15 2.22-1.49 0.86-0.36 1.78-0.55 2.73-0.56 0.94 0 1.86 0.19 2.72 0.56 0.83 0.35 1.58 0.86 2.22 1.49 0.64 0.64 1.15 1.39 1.5 2.23 0.36 0.86 0.55 1.78 0.55 2.72 0 0.94-0.19 1.86-0.55 2.73-0.35 0.83-0.86 1.58-1.5 2.22-0.64 0.64-1.39 1.15-2.22 1.5-0.86 0.36-1.78 0.55-2.72 0.55z m0-13c-3.31 0-6 2.69-6 6 0 3.31 2.69 6 6 6 3.31 0 6-2.69 5.99-6 0-3.31-2.69-6-5.99-6z M9.87 4.61c0.2 0.19 0.2 0.51 0.01 0.71l-2.77 2.83 2.75 2.51c0.2 0.19 0.22 0.5 0.03 0.7-0.1 0.11-0.23 0.16-0.37 0.17-0.12 0-0.24-0.05-0.33-0.14l-3.13-2.84c-0.2-0.19-0.22-0.5-0.03-0.71 0.03-0.03 0.06-0.06 0.1-0.08 0.02-0.04 0.05-0.08 0.08-0.12l2.95-3.02c0.19-0.2 0.51-0.2 0.71-0.01z ",
      "M7.99 15.01c0.94 0 1.86-0.19 2.72-0.55 0.83-0.35 1.58-0.86 2.22-1.5 0.64-0.64 1.15-1.39 1.5-2.22 0.36-0.86 0.55-1.78 0.55-2.73 0-0.94-0.19-1.86-0.55-2.72-0.35-0.83-0.86-1.58-1.5-2.23-0.64-0.64-1.39-1.15-2.22-1.49-0.86-0.36-1.78-0.55-2.72-0.56-0.94 0-1.86 0.19-2.73 0.56-0.83 0.35-1.58 0.86-2.22 1.49-0.64 0.64-1.15 1.39-1.5 2.23-0.36 0.86-0.55 1.78-0.55 2.72 0 0.94 0.19 1.86 0.55 2.73 0.35 0.83 0.86 1.58 1.5 2.22 0.64 0.64 1.39 1.15 2.22 1.5 0.86 0.36 1.78 0.55 2.73 0.55z m0-13c3.31 0 6 2.69 5.99 6 0 3.31-2.69 6-5.99 6-3.31 0-6-2.69-6-6 0-3.31 2.69-6 6-6z M6.22 4.61c0.2-0.19 0.51-0.19 0.71 0.01l0 0 2.95 3.02c0.12 0.12 0.16 0.28 0.13 0.44 0.03 0.17-0.02 0.35-0.15 0.47l0 0-3.12 2.84c-0.09 0.08-0.21 0.13-0.34 0.14-0.14 0-0.27-0.06-0.37-0.17-0.19-0.2-0.17-0.52 0.03-0.7l0 0 2.84-2.59-2.69-2.75c-0.17-0.18-0.19-0.45-0.05-0.64z ",
    ];
    if (opt.legend && opt.legend.enable) {
      if (opt.legend.position === "left") {
        legend["left"] = "left";
        legend["top"] = "middle";
        legend.orient = "vertical";
        if (legend.type === "scroll") {
          legend.pageIcons = {
            vertical: shangxiacustomTag,
          };
        }
      } else if (opt.legend.position === "right") {
        legend["left"] = "right";
        legend["top"] = "middle";
        legend.orient = "vertical";
        if (legend.type == "scroll") {
          legend.pageIcons = {
            vertical: shangxiacustomTag,
          };
        }
      } else if (opt.legend.position === "top") {
        legend["top"] = "top";
        legend["left"] = "center";
        legend.orient = "horizontal";
        if (legend.type == "scroll") {
          legend.pageIcons = {
            horizontal: zuoyoucustomTag,
          };
        }
      } else if (opt.legend.position === "bottom") {
        legend["top"] = "bottom";
        legend["left"] = "center";
        legend.orient = "horizontal";
        if (legend.type == "scroll") {
          legend.pageIcons = {
            horizontal: zuoyoucustomTag,
          };
        }
      } else {
        legend["top"] = "bottom";
        legend["left"] = "center";
        legend.orient = "horizontal";
        if (legend.type == "scroll") {
          legend.pageIcons = {
            horizontal: zuoyoucustomTag,
          };
        }
      }
    }

    newOpthon.legend = legend;
    newOpthon.tooltip = {
      ..._.attrList.tooltip,
      ...{
        confine: true,
        formatter: (s) => {
          if (s.componentType == "markLine") {
            return "";
          }
          let y = "";
          if (BsyUtils.isArray(s)) {
            switch (s.componentSubType) {
              case "radar": {
                _.indicatorIndex = s.indicatorIndex;
                let y =
                  (_.attrList.tooltip.seriesName
                    ? _.attrList.tooltip.seriesName
                    : "") +
                  newOpthon.series[0].data[0].datamap[s.indicatorIndex].name;
                let h = "";
                BsyUtils.forEach(newOpthon.series[0].data, (obj, val) => {
                  if (val.value[s.indicatorIndex] !== null) {
                    if (h) h += "<br />";

                    h +=
                      s.marker +
                      val.name +
                      ": " +
                      _._formatValue(val.value[s.indicatorIndex], obj);
                  }
                });
                if (h) {
                  y += "<br />" + h;
                } else y = "";
                return y;
              }
              default: {
                y = s[0].name;
                if (_.attrList.tooltip.seriesName) {
                  y = _.attrList.tooltip.seriesName;
                }
                BsyUtils.forEach(s, (obj, val) => {
                  if (val) {
                    if (
                      val.data &&
                      typeof val.data == "object" &&
                      val.data.hasOwnProperty("value")
                    ) {
                      if (val.data.value !== null) {
                        if (y) y += "<br />";
                        y +=
                          val.seriesName +
                          ": " +
                          _._formatValue(val.data.value, obj);
                      }
                    } else {
                      if (val.data !== null) {
                        if (y) y += "<br />";
                        y +=
                          val.seriesName + ": " + _._formatValue(val.data, obj);
                      }
                    }
                  }
                });
                break;
              }
            }
          } else {
            switch (s.componentSubType) {
              case "pie": {
                let y = "";
                if (_.attrList.tooltip.seriesName) {
                  y = _.attrList.tooltip.seriesName + "<br>";
                } else {
                  y += s.name + "<br>";
                }

                y +=
                  _._formatValue(seriesdata[s.dataIndex][0], s.seriesIndex) +
                  "<br>";
                y += s.percent + "%";
                return y;
              }
              case "funnel": {
                let y = "";
                if (_.attrList.tooltip.seriesName) {
                  y = _.attrList.tooltip.seriesName + "<br>";
                } else {
                  y += s.name + "<br>";
                }

                y += _._formatValue(s.value, s.dataIndex);
                return y;
              }
              case "radar": {
                _.indicatorIndex = s.indicatorIndex;
                let y = "";
                if (_.attrList.tooltip.seriesName) {
                  y = _.attrList.tooltip.seriesName;
                } else {
                  y =
                    newOpthon.series[0].data[0].datamap[s.indicatorIndex].name;
                }

                let h = "";
                BsyUtils.forEach(newOpthon.series[0].data, (obj, val) => {
                  if (val.value[s.indicatorIndex] !== null) {
                    if (h) h += "<br />";
                    h +=
                      s.marker +
                      val.name +
                      ": " +
                      _._formatValue(val.value[s.indicatorIndex], obj);
                  }
                });
                if (h) {
                  y += "<br />" + h;
                } else y = "";
                return y;
              }
              default: {
                y = s.name;
                if (_.attrList.tooltip.seriesName) {
                  y = _.attrList.tooltip.seriesName;
                }
                let val = s;
                if (
                  val.data &&
                  typeof val.data == "object" &&
                  val.data.hasOwnProperty("value")
                ) {
                  if (y) y += "<br />";

                  y +=
                    val.seriesName +
                    ": " +
                    _._formatValue(val.data.value, s.componentIndex);
                } else {
                  if (y) y += "<br />";
                  y +=
                    val.seriesName +
                    ": " +
                    _._formatValue(val.data, s.componentIndex);
                }
                break;
              }
            }
          }
          return y;
        },
        trigger: "axis",
      },
    };
    newOpthon.tooltip.position =
      this.attrList.tooltip.position == "0"
        ? undefined
        : this.attrList.tooltip.position;
    newOpthon.tooltip.seriesName = undefined;
    newOpthon.tooltip.backgroundColor = this.tooltipColor;

    //刻度线信息
    let axisLine = {
      show: true,
      onZero: false,
      lineStyle: {
        color: _.indicatorColor,
        zlevel: 10,
      },
    };
    let axisLabel = {
      show: true,
      color: _.indicatorColor,
      splitLine: {
        lineStyle: {
          color: _.splitColor,
        },
      },
    };

    let tmpdata = JSON.parse(JSON.stringify(seriesdata));
    BsyUtils.forEach(tmpdata, (a1, b1) => {
      BsyUtils.forEach(b1, (a2, b2) => {
        if (b2 === null) {
          tmpdata[a1][a2] = 0;
        }
      });
    });
    let labelLayout = {};
    let markLine = null;
    let yAxis = {};
    let xAxis = {};
    let charttype = "bar";
    switch (this.state.chartType) {
      case "line_chart": //折线
      case "area_chart": //面积
      case "column_chart": {
        //柱型
        if (
          this.state.chartType === "area_chart" ||
          this.state.chartType === "line_chart"
        ) {
          charttype = "line";
        }
        let indMax = 0;
        let indMin = 0;

        if (this.state.chartType == "area_chart") {
          BsyUtils.forEach(tmpdata, (t, e) => {
            let tmpmax = Math.max.apply(null, e);
            // if(tmpmax > indMax)
            indMax += tmpmax;
            let tmpmin = Math.min.apply(null, e);
            // if(tmpmin < indMin)
            indMin += tmpmin;
          });
        } else {
          BsyUtils.forEach(tmpdata, (t, e) => {
            let tmpmax = Math.max.apply(null, e);
            if (tmpmax > indMax) indMax = tmpmax;
            let tmpmin = Math.min.apply(null, e);
            if (tmpmin < indMin) indMin = tmpmin;
          });
        }

        if (opt.column_type === "category") {
          newOpthon.polar = {
            center: ["50%", "50%"],
            radius: "50%",
          };
          newOpthon.angleAxis = {
            type: "category",
            data: xAxisData,
            axisLine: { ...axisLine },
            axisLabel: { ...{ fontSize: 10 }, ...axisLabel },
          };
          newOpthon.radiusAxis = {
            type: "value",
            data: xAxisData,
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value);
                  return s;
                },
              },
            },
            z: 10,
          };

          _._renderPolar(newOpthon, legenddata);
        } else {
          markLine = _._addThresholdLine();

          newOpthon.yAxis = {
            type: "value",
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value);
                  // yticks0.push(s);
                  return s;
                },
              },
            },
          };

          if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
            if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
              newOpthon.yAxis.max = _.yAxes[0].max;
            if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null)
              newOpthon.yAxis.min = _.yAxes[0].min;

            if (
              _.yAxes[0].hasOwnProperty("minInterval") &&
              _.yAxes[0].minInterval !== null
            )
              newOpthon.yAxis.minInterval = _.yAxes[0].minInterval;
            if (
              _.yAxes[0].hasOwnProperty("maxInterval") &&
              _.yAxes[0].maxInterval !== null
            )
              newOpthon.yAxis.maxInterval = _.yAxes[0].maxInterval;

            if (
              _.yAxes[0].hasOwnProperty("title") &&
              _.yAxes[0].title &&
              _.yAxes[0].title.text
            ) {
              newOpthon.yAxis.name = _.yAxes[0].title.text;
              newOpthon.yAxis.nameGap = _._getTickLeng() + 10;
              newOpthon.yAxis.nameLocation = "center";
              newOpthon.yAxis.nameRotate = 90;
              newOpthon.yAxis.nameTextStyle = {
                color: this.indicatorColor,
              };
            }
          }

          if (markLine) {
            let markLineValue = _.niceTicks(markLine.min, markLine.max);

            if (this.newOpthon.yAxis.hasOwnProperty("max")) {
              if (markLine.max > newOpthon.yAxis.max) {
                newOpthon.yAxis.max = markLineValue[1];
              }
            } else {
              if (markLine.max >= indMax) {
                newOpthon.yAxis.max = markLineValue[1];
              }
            }

            if (this.newOpthon.yAxis.hasOwnProperty("min")) {
              if (markLine.min < newOpthon.yAxis.min) {
                newOpthon.yAxis.min = markLineValue[0];
              }
            } else {
              if (markLine.min <= indMin)
                newOpthon.yAxis.min = markLineValue[0];
            }

            if (newOpthon.yAxis.name) {
              newOpthon.yAxis.nameGap = _._getTickLeng() + 10;
            }
          }

          newOpthon.xAxis = {
            type: "category",
            data: xAxisData,
            axisLine: { ...axisLine },
            axisLabel: { ...{ fontSize: 10 }, ...axisLabel },
            labelStyle: {
              fontFamily: "Verdana",
              color: this.textColor,
              fontSize: "10px",
            },
          };
          if (this.props.xAxis.hasOwnProperty("label")) {
            if (this.props.xAxis.label.step) {
              newOpthon.xAxis.axisLabel.interval = 0; //强制显示文字
            }
            newOpthon.xAxis.axisLabel.rotate =
              0 - this.props.xAxis.label.rotation;
          }

          newOpthon.grid = _._renderGrid(legenddata, xAxisData, seriesdata);
        }

        newOpthon.series = [];

        //刻度信息
        let tickInfo = _._getDataNiceTicks();
        BsyUtils.forEach(tmpdata, (a1, b1) => {
          let data = [];

          let todata = (d) => {
            let s = [];
            BsyUtils.forEach(d, (a11, b11) => {
              let post = b11 >= 0 ? "top" : "bottom";
              if (tickInfo[0] == b11) {
                post = "insideBottom";
              } else if (tickInfo[0] == b11) {
                post = "insideTop";
              } else if (
                newOpthon.yAxis &&
                newOpthon.yAxis.hasOwnProperty("min") &&
                newOpthon.yAxis.min !== null &&
                b11 < newOpthon.yAxis.min
              ) {
                post = "insideBottom";
              } else if (
                newOpthon.yAxis &&
                newOpthon.yAxis.hasOwnProperty("max") &&
                newOpthon.yAxis.max !== null &&
                b11 > newOpthon.yAxis.max
              ) {
                post = "insideTop";
              }

              switch (_.state.chartType) {
                case "line_chart": //折线
                case "area_chart": {
                  //面积
                  post = "top";
                  break;
                }
                default: {
                  break;
                }
              }

              let itmevel = {
                value: b11,
                name: xAxisData[a11],
                label: {
                  ...{ fontSize: 10 },
                  ..._.attrList.label,
                  ...{
                    show: !opt.chart_label ? false : opt.chart_label.enable,
                    color: _.textColor,
                    position: post,
                    formatter: (s) => {
                      return _._labelformatter(s, seriesdata);
                    },
                  },
                },
              };
              if (seriesdata.length == 1) {
                itmevel.itemStyle = {
                  color: newOpthon.color[a11],
                };
              }
              s.push(itmevel);
            });
            return s;
          };
          data = todata(b1);

          let tmp = {
            type: charttype,
            data: data,
            name: legenddata[a1],
            labelLayout: (params) => {
              if (!params.text) {
                return {
                  x: params.labelRect.x,
                  y: params.labelRect.y,
                };
              }
              let key = _._getLabelKey(params.seriesIndex, params.dataIndex);
              labelLayout[key] = { ...params.labelRect, text: params.text };
              // console.log('key', params.seriesIndex, params.dataIndex)
              // console.log('params', { ...params.labelRect, text: params.text })
              // console.log('all', labelLayout)
              let posindex = 0;

              while (true) {
                let outRect = {};
                if (
                  _.isOverlapped(labelLayout[key], labelLayout, key, outRect)
                ) {
                  posindex++;
                  labelLayout[key].y = params.labelRect.y - posindex * 20;
                  //超出了边缘部分，还原到默认位置
                  if (labelLayout[key].y <= 0 + newOpthon.grid.top) {
                    labelLayout[key].y = params.labelRect.y;
                    return {
                      x: params.labelRect.x,
                      y: params.labelRect.y,
                    };
                  }
                } else {
                  if (
                    this.echartsRef.current.offsetHeight -
                      labelLayout[key].y -
                      parseInt(_.attrList.label.fontSize || 10) <=
                    newOpthon.grid.bottom
                  ) {
                    //计算底部超过部分
                    labelLayout[key].y =
                      this.echartsRef.current.offsetHeight -
                      newOpthon.grid.bottom -
                      parseInt(_.attrList.label.fontSize || 10);
                  }
                  if (labelLayout[key].y <= newOpthon.grid.top) {
                    labelLayout[key].y =
                      newOpthon.grid.top +
                      parseInt(_.attrList.label.fontSize || 10);
                  }
                  return {
                    x: labelLayout[key].x,
                    y: labelLayout[key].y,
                  };
                }
              }
              return {
                x: params.labelRect.x,
                y: params.labelRect.y,
              };
            },
            showAllSymbol: true,
            label: {
              show: !opt.chart_label ? false : opt.chart_label.enable,
              // position: 'middle',   echarts5.2以后的版本  才支持 柱状态图极坐标显示 标签
              // formatter: '{b}',
              // emphasis: {
              //     textStyle: {
              //         fontSize: _.attrList.label.fontSize + 4,
              //     },
              // }
            },
            itemStyle: {
              emphasis: {
                borderColor: BsyUtils.hexToRGBAStr(newOpthon.color[a1], 0.5),
                borderWidth: 6,
                label: {
                  fontSize:
                    _.attrList.label.fontSize +
                    (_.attrList.label.fontSize >= 22 ? 0 : 4),
                },
              },
              normal: {
                color: newOpthon.color[a1],
              },
            },
          };
          if (_.state.chartType == "area_chart") {
            tmp.stack = "area_chart";
            tmp.areaStyle = {};
            newOpthon.tooltip.trigger = "axis";
            // newOpthon.xAxis.boundaryGap = false;
          }
          if (_.state.chartType == "line_chart") {
            newOpthon.tooltip.trigger = "axis";
            // newOpthon.xAxis.boundaryGap = false;
          }

          if (_.state.chartType == "column_chart") {
            newOpthon.tooltip.trigger = undefined;
          }

          if (opt.column_type == "category") {
            tmp.coordinateSystem = "polar";
          }
          if (markLine) tmp.markLine = markLine;
          newOpthon.series.push(tmp);
        });
        break;
      }
      case "multi_axes_chart": {
        //双轴
        let leftA = false;
        let rightA = false;

        let markLine = _._addThresholdLine();

        BsyUtils.forEach(_.metrics, (a1, b1) => {
          if (b1.metricType == "left") {
            leftA = true;
          } else if (b1.metricType == "right") {
            rightA = true;
          }
        });

        newOpthon.series = [];
        let tmpdata = JSON.parse(JSON.stringify(seriesdata));
        BsyUtils.forEach(tmpdata, (a1, b1) => {
          BsyUtils.forEach(b1, (a2, b2) => {
            if (b2 === null) {
              tmpdata[a1][a2] = 0;
            }
          });
        });
        BsyUtils.forEach(tmpdata, (t, e) => {
          let h = {};
          let c =
            leftA && rightA
              ? _.metrics[t] && "left" === _.metrics[t].metricType
                ? 0
                : 1
              : 0;

          let tickInfo = _._getDataNiceTicks(_.metrics[t].metricType);
          let tmp = {};
          if (c == 0) tmp.type = "bar";
          else tmp.type = "line";
          let chart_type = "column_chart";
          if (
            _.yAxes.length > 0 &&
            _.yAxes[_.metrics[t].metricType == "left" ? 0 : 1].chart_type
          ) {
            chart_type =
              _.yAxes[_.metrics[t].metricType == "left" ? 0 : 1].chart_type;
          }
          switch (chart_type) {
            case "area_chart": {
              //面积
              tmp.stack = "area_chart";
              tmp.areaStyle = {};
              tmp.type = "line";
              break;
            }
            case "stacked_column_chart": {
              tmp.type = "bar";
              tmp.stack = "stack" + c;
              break;
            }
            case "column_chart": {
              tmp.type = "bar";

              break;
            }
            case "line_chart": {
              //折线
              tmp.type = "line";
              break;
            }
            default: {
              break;
            }
          }

          let todata = (d) => {
            let s = [];
            BsyUtils.forEach(d, (a11, b11) => {
              let post = b11 >= 0 ? "top" : "bottom";
              if (tickInfo[0] == b11) {
                post = "insideBottom";
              } else if (tickInfo[0] == b11) {
                post = "insideTop";
              } else if (
                _.yAxes[c] &&
                _.yAxes[c].hasOwnProperty("min") &&
                _.yAxes[c].min !== null &&
                b11 < _.yAxes[c].min
              ) {
                post = "insideBottom";
              } else if (
                _.yAxes[c] &&
                _.yAxes[c].hasOwnProperty("max") &&
                _.yAxes[c].max !== null &&
                b11 > _.yAxes[c].max
              ) {
                post = "insideTop";
              }

              // switch(_.props.chartType)
              // {
              //     case "line_chart":  //折线
              //     case "area_chart":      //面积
              //         post = "top";
              //         break;
              // }

              switch (chart_type) {
                case "line_chart": //折线
                case "area_chart": {
                  //面积
                  post = "top";
                  //面积图为null 需要把数据 转换成0 否则会造成图像不完成
                  break;
                }

                default: {
                  break;
                }
              }

              let itmevel = {
                value: b11,
                name: xAxisData[a11],
                label: {
                  ...{ fontSize: 10 },
                  ..._.attrList.label,
                  ...{
                    show: !opt.chart_label ? false : opt.chart_label.enable,
                    color: _.textColor,
                    position: post,
                    formatter: (s) => {
                      return _._labelformatter(s, seriesdata);
                    },
                  },
                },
              };
              if (seriesdata.length == 1) {
                itmevel.itemStyle = {
                  color: newOpthon.color[a11],
                };
              }
              s.push(itmevel);
            });
            return s;
          };
          let data = todata(e);

          tmp = {
            ...{},
            ...tmp,
            ...{
              // type:chartType,
              data: data,
              xAxisIndex: 0,
              yAxisIndex: c,
              name: legenddata[t],
              markLine: markLine[_.metrics[t].metricType == "left" ? 0 : 1],
              labelLayout: (params) => {
                if (!params.text) {
                  return {
                    x: params.labelRect.x,
                    y: params.labelRect.y,
                  };
                }
                let key = _._getLabelKey(params.seriesIndex, params.dataIndex);
                labelLayout[key] = { ...params.labelRect, text: params.text };
                let posindex = 0;
                while (true) {
                  let outRect = {};
                  if (
                    _.isOverlapped(labelLayout[key], labelLayout, key, outRect)
                  ) {
                    posindex++;
                    labelLayout[key].y = params.labelRect.y - posindex * 20;

                    //超出了边缘部分，还原到默认位置
                    if (labelLayout[key].y <= 0 + newOpthon.grid.top) {
                      labelLayout[key].y = params.labelRect.y;
                      return {
                        x: params.labelRect.x,
                        y: params.labelRect.y,
                      };
                    }
                  } else {
                    if (
                      this.echartsRef.current.offsetHeight -
                        labelLayout[key].y -
                        parseInt(_.attrList.label.fontSize || 10) <=
                      newOpthon.grid.bottom
                    ) {
                      //计算底部超过部分
                      labelLayout[key].y =
                        this.echartsRef.current.offsetHeight -
                        newOpthon.grid.bottom -
                        parseInt(_.attrList.label.fontSize || 10);
                    }
                    if (labelLayout[key].y <= newOpthon.grid.top) {
                      labelLayout[key].y =
                        newOpthon.grid.top +
                        parseInt(_.attrList.label.fontSize || 10);
                    }
                    return {
                      x: labelLayout[key].x,
                      y: labelLayout[key].y,
                    };
                  }
                }
                return {
                  x: params.labelRect.x,
                  y: params.labelRect.y,
                };
              },
              label: {
                ...{},
                ..._.attrList.label,
                ...{
                  show: !opt.chart_label ? false : opt.chart_label.enable,
                  color: _.textColor,
                  position: "top",
                  formatter: (s) => {
                    if (
                      s.data &&
                      typeof s.data == "object" &&
                      s.data.hasOwnProperty("value")
                    ) {
                      return _._formatValue(s.data.value, s.seriesIndex);
                    }
                    return _._formatValue(s.data, s.seriesIndex);
                  },
                },
              },
              itemStyle: {
                emphasis: {
                  borderColor: BsyUtils.hexToRGBAStr(newOpthon.color[t], 0.5),
                  borderWidth: 6,
                  label: {
                    fontSize:
                      _.attrList.label.fontSize +
                      (_.attrList.label.fontSize >= 22 ? 0 : 4),
                  },
                },
                normal: {
                  color: newOpthon.color[t],
                },
              },
            },
          };

          newOpthon.series.push(tmp);
        });

        xAxis = {
          type: "category",
          data: xAxisData,
          axisLine: { ...axisLine },
          axisLabel: { ...{ fontSize: 10 }, ...axisLabel },
          labelStyle: {
            fontFamily: "Verdana",
            color: this.textColor,
            fontSize: 10,
          },
        };
        if (this.props.xAxis.hasOwnProperty("label")) {
          if (this.props.xAxis.label.step) {
            xAxis.axisLabel.interval = 0; //强制显示文字
          }
          xAxis.axisLabel.rotate = 0 - this.props.xAxis.label.rotation;
        }

        newOpthon.xAxis = { ...xAxis };
        newOpthon.yAxis = [];

        if (leftA) {
          let indMax = 0;
          let indMin = 0;

          if (_.yAxes[0].chart_type == "area_chart") {
            BsyUtils.forEach(seriesdata, (t, e) => {
              let c =
                leftA && rightA
                  ? _.metrics[t] && "left" === _.metrics[t].metricType
                    ? 0
                    : 1
                  : 0;
              if (c == 1) {
                return !0;
              }

              let tmpmax = Math.max.apply(null, e);
              // if(tmpmax > indMax)
              indMax += tmpmax;
              let tmpmin = Math.min.apply(null, e);
              // if(tmpmin < indMin)
              indMin += tmpmin;
            });
          } else {
            BsyUtils.forEach(seriesdata, (t, e) => {
              let c =
                leftA && rightA
                  ? _.metrics[t] && "left" === _.metrics[t].metricType
                    ? 0
                    : 1
                  : 0;
              if (c == 1) {
                return !0;
              }

              let tmpmax = Math.max.apply(null, e);
              if (tmpmax > indMax) indMax = tmpmax;
              let tmpmin = Math.min.apply(null, e);
              if (tmpmin < indMin) indMin = tmpmin;
            });
          }

          let leftyAxis = {
            type: "value",
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value, "left");
                  // yticks0.push(s);
                  return s;
                },
              },
            },
          };
          newOpthon.yAxis.push(leftyAxis);

          if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
            if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
              leftyAxis.max = _.yAxes[0].max;
            if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null)
              leftyAxis.min = _.yAxes[0].min;

            if (
              _.yAxes[0].hasOwnProperty("minInterval") &&
              _.yAxes[0].minInterval !== null
            )
              leftyAxis.minInterval = _.yAxes[0].minInterval;
            if (
              _.yAxes[0].hasOwnProperty("maxInterval") &&
              _.yAxes[0].maxInterval !== null
            )
              leftyAxis.maxInterval = _.yAxes[0].maxInterval;

            if (
              _.yAxes[0].hasOwnProperty("title") &&
              _.yAxes[0].title &&
              _.yAxes[0].title.text
            ) {
              leftyAxis.name = _.yAxes[0].title.text;
              leftyAxis.nameGap = _._getTickLeng("left") + 10;
              leftyAxis.nameLocation = "center";
              leftyAxis.nameRotate = 90;
              leftyAxis.nameTextStyle = {
                color: this.indicatorColor,
              };
            }
          }
          if (markLine[0] && !BsyUtils.isObjectEmpty(markLine[0].data)) {
            let markLineValue = _.niceTicks(markLine[0].min, markLine[0].max);

            if (leftyAxis.hasOwnProperty("max")) {
              if (markLine[0].max > leftyAxis.max) {
                leftyAxis.max = markLineValue[1];
              }
            } else {
              if (markLine[0].max >= indMax) {
                leftyAxis.max = markLineValue[1];
              }
            }

            if (leftyAxis.hasOwnProperty("min")) {
              if (markLine[0].min < leftyAxis.min) {
                leftyAxis.min = markLineValue[0];
              }
            } else {
              if (markLine[0].min <= indMin) leftyAxis.min = markLineValue[0];
            }
            if (leftyAxis.name) {
              leftyAxis.nameGap = _._getTickLeng("left") + 10;
            }
          }
        }

        if (rightA) {
          let indMax = 0;
          let indMin = 0;
          if (_.yAxes[1].chart_type == "area_chart") {
            BsyUtils.forEach(seriesdata, (t, e) => {
              let c =
                leftA && rightA
                  ? _.metrics[t] && "left" === _.metrics[t].metricType
                    ? 0
                    : 1
                  : 0;
              if (leftA && rightA && c == 0) {
                return !0;
              }

              let tmpmax = Math.max.apply(null, e);
              // if(tmpmax > indMax)
              indMax += tmpmax;
              let tmpmin = Math.min.apply(null, e);
              // if(tmpmin < indMin)
              indMin += tmpmin;
            });
          } else {
            BsyUtils.forEach(seriesdata, (t, e) => {
              let c =
                leftA && rightA
                  ? _.metrics[t] && "left" === _.metrics[t].metricType
                    ? 0
                    : 1
                  : 0;
              if (leftA && rightA && c == 0) {
                return !0;
              }

              let tmpmax = Math.max.apply(null, e);
              if (tmpmax > indMax) indMax = tmpmax;
              let tmpmin = Math.min.apply(null, e);
              if (tmpmin < indMin) indMin = tmpmin;
            });
          }

          let rightyAxis = {
            type: "value",
            position: "right",
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value, "right");
                  return s;
                },
              },
            },
          };

          newOpthon.yAxis.push(rightyAxis);
          if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 1) {
            if (_.yAxes[1].hasOwnProperty("max") && _.yAxes[1].max !== null)
              rightyAxis.max = _.yAxes[1].max;
            if (_.yAxes[1].hasOwnProperty("min") && _.yAxes[1].min !== null)
              rightyAxis.min = _.yAxes[1].min;

            if (
              _.yAxes[1].hasOwnProperty("minInterval") &&
              _.yAxes[1].minInterval !== null
            )
              rightyAxis.minInterval = _.yAxes[1].minInterval;
            if (
              _.yAxes[1].hasOwnProperty("maxInterval") &&
              _.yAxes[1].maxInterval !== null
            )
              rightyAxis.maxInterval = _.yAxes[1].maxInterval;

            if (
              _.yAxes[1].hasOwnProperty("title") &&
              _.yAxes[1].title &&
              _.yAxes[1].title.text
            ) {
              rightyAxis.name = _.yAxes[1].title.text;
              rightyAxis.nameGap = _._getTickLeng("right") + 10;
              rightyAxis.nameLocation = "center";
              rightyAxis.nameRotate = 270;
              rightyAxis.nameTextStyle = {
                color: this.indicatorColor,
              };
            }
          }

          if (markLine[1] && !BsyUtils.isObjectEmpty(markLine[1].data)) {
            let markLineValue = _.niceTicks(markLine[1].min, markLine[1].max);

            if (markLine[1].max >= indMax) {
              if (rightyAxis.hasOwnProperty("max")) {
                if (markLine[1].max >= rightyAxis.max) {
                  rightyAxis.max = markLineValue[1];
                }
              } else {
                if (markLine[1].max >= indMax)
                  rightyAxis.max = markLineValue[1];
              }
            }

            if (rightyAxis.hasOwnProperty("min")) {
              if (markLine[1].min <= rightyAxis.min) {
                rightyAxis.min = markLineValue[0];
              }
            } else {
              if (markLine[1].min <= indMin) rightyAxis.min = markLineValue[0];
            }
            if (rightyAxis.name) {
              rightyAxis.nameGap = _._getTickLeng("right") + 10;
            }
          }
        }

        newOpthon.grid = _._renderGrid(legenddata, xAxisData, seriesdata);
        break;
      }
      case "bar_chart": {
        //条型
        newOpthon.tooltip.trigger = undefined;
        let tmpdata = JSON.parse(JSON.stringify(seriesdata));
        BsyUtils.forEach(tmpdata, (a1, b1) => {
          BsyUtils.forEach(b1, (a2, b2) => {
            if (b2 === null) {
              tmpdata[a1][a2] = 0;
            }
          });
        });
        let indMax = 0;
        let indMin = 0;
        BsyUtils.forEach(tmpdata, (t, e) => {
          let tmpmax = Math.max.apply(null, e);
          if (tmpmax > indMax) indMax = tmpmax;
          let tmpmin = Math.min.apply(null, e);
          if (tmpmin < indMin) indMin = tmpmin;
        });

        if (opt.column_type == "category") {
          newOpthon.polar = {
            center: ["50%", "50%"],
            radius: "50%",
          };
          newOpthon.angleAxis = {
            type: "value",
            data: xAxisData,
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value);
                  // yticks0.push(s);
                  return s;
                },
              },
            },
          };
          newOpthon.radiusAxis = {
            type: "category",
            data: xAxisData,
            axisLine: { ...axisLine },
            axisLabel: { ...{ fontSize: 10 }, ...axisLabel },
            z: 10,
          };
          _._renderPolar(newOpthon, legenddata);
        } else {
          let sdf = JSON.parse(JSON.stringify(xAxisData));

          yAxis = {
            type: "category",
            data: sdf.reverse(),
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                // interval = (s1,s2){
                //     console.log(s1,s2)
                // }
              },
            },
          };

          xAxis = {
            type: "value",
            position: "top",
            axisLine: { ...axisLine },
            axisLabel: {
              ...{ fontSize: 10 },
              ...axisLabel,
              ...{
                formatter: (value, index) => {
                  let s = _.formatAxisValue(value);
                  // yticks0.push(s);
                  return s;
                },
              },
            },
            splitLine: {
              show: true,
            },
            boundaryGap: true,
            labelStyle: {
              fontFamily: "Verdana",
              color: this.textColor,
              fontSize: "10px",
            },
          };

          if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
            if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
              xAxis.max = _.yAxes[0].max;
            if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].min !== null)
              xAxis.min = _.yAxes[0].min;

            if (
              _.yAxes[0].hasOwnProperty("minInterval") &&
              _.yAxes[0].minInterval !== null
            )
              xAxis.minInterval = _.yAxes[0].minInterval;
            if (
              _.yAxes[0].hasOwnProperty("maxInterval") &&
              _.yAxes[0].maxInterval !== null
            )
              xAxis.maxInterval = _.yAxes[0].maxInterval;

            if (
              _.yAxes[0].hasOwnProperty("title") &&
              _.yAxes[0].title &&
              _.yAxes[0].title.text
            ) {
              xAxis.name = _.yAxes[0].title.text;
              xAxis.nameGap = 30;
              xAxis.nameLocation = "center";

              xAxis.nameTextStyle = {
                color: this.indicatorColor,
              };
            }
          }

          newOpthon.xAxis = { ...xAxis };
          newOpthon.yAxis = { ...yAxis };
          newOpthon.grid = _._renderBarGrid(legenddata, xAxisData, seriesdata);

          markLine = _._addThresholdLine();
          if (newOpthon.hasOwnProperty("xAxis") && markLine) {
            let markLineValue = _.niceTicks(markLine.min, markLine.max);

            if (newOpthon.xAxis.hasOwnProperty("max")) {
              if (markLine.max >= newOpthon.xAxis.max) {
                newOpthon.xAxis.max = markLineValue[1];
              }
            } else {
              if (markLine.max >= indMax)
                newOpthon.xAxis.max = markLineValue[1];
            }

            if (newOpthon.xAxis.hasOwnProperty("min")) {
              if (markLine.min <= newOpthon.xAxis.min) {
                newOpthon.xAxis.min = markLineValue[0];
              }
            } else {
              if (markLine.min <= indMin)
                newOpthon.xAxis.min = markLineValue[0];
            }
          }
          if (markLine) {
            BsyUtils.forEach(markLine.data, (z1, z2) => {
              markLine.data[z1].xAxis = markLine.data[z1].yAxis;
              markLine.data[z1].label.position = "insideEndTop";
              delete markLine.data[z1].yAxis;
            });
            // newOpthon.series[0].markLine = markLine;
          }
        }

        newOpthon.series = [];

        let tickInfo = _._getDataNiceTicks();
        BsyUtils.forEach(tmpdata, (a1, b1) => {
          let data = [];

          let todata = (d) => {
            let s = [];
            BsyUtils.forEach(d, (a11, b11) => {
              let post = b11 >= 0 ? "right" : "left";
              if (tickInfo[0] == b11) {
                post = "insideLeft";
              } else if (tickInfo[0] == b11) {
                post = "insideRight";
              } else if (
                newOpthon.xAxis &&
                newOpthon.xAxis.hasOwnProperty("min") &&
                newOpthon.xAxis.min !== null &&
                b11 < newOpthon.xAxis.min
              ) {
                post = "insideLeft";
              } else if (
                newOpthon.xAxis &&
                newOpthon.xAxis.hasOwnProperty("max") &&
                newOpthon.xAxis.max !== null &&
                b11 > newOpthon.xAxis.max
              ) {
                post = "insideRight";
              }

              let itmevel = {
                value: b11,
                name: xAxisData[a11],
                label: {
                  ...{ fontSize: 10 },
                  ..._.attrList.label,
                  ...{
                    show: !opt.chart_label ? false : opt.chart_label.enable,
                    color: _.textColor,
                    position: post,
                    formatter: (s) => {
                      return _._labelformatter(s, seriesdata);
                    },
                  },
                },
              };
              if (seriesdata.length == 1) {
                itmevel.itemStyle = {
                  color: newOpthon.color[a11],
                };
              }
              s.push(itmevel);
            });
            return s;
          };
          data = todata(b1);
          data = data.reverse();
          let tmp = {
            type: charttype,
            data: data,
            labelLayout: (params) => {
              if (!params.text) {
                return {
                  x: params.labelRect.x,
                  y: params.labelRect.y,
                };
              }
              let key = _._getLabelKey(params.seriesIndex, params.dataIndex);

              labelLayout[key] = { ...params.labelRect, text: params.text };

              // $("<div class='test-abc ggg-'  style='left:"+params.labelRect.x+"px;top:"+params.labelRect.y +"px;width:"+params.labelRect.width+"px;height:"+params.labelRect.height+"px;background:red;position:fixed;z-index:99999' />").appendTo("body");
              // $("<div class='test-abc ggg-'  style='left:"+params.rect.x+"px;top:"+params.rect.y +"px;width:"+params.rect.width+"px;height:"+params.rect.height+"px;background:red;position:fixed;z-index:99999' />").appendTo("body");

              while (true) {
                let outRect = {};
                if (
                  _.isOverlapped(labelLayout[key], labelLayout, key, outRect)
                ) {
                  // posindex++;
                  //labelLayout[params.seriesIndex][params.dataIndex].y = params.labelRect.y - (posindex) * 20;

                  labelLayout[key].x = outRect.x + outRect.width + 5;
                  // if(params.text == "8880")
                  // console.log(this.echartsRef.current.offsetWidth - (labelLayout[key].x + labelLayout[key].width), newOpthon.grid.right,params.text)
                  // //超出了边缘部分，还原到默认位置
                  if (
                    this.echartsRef.current.offsetWidth -
                      (labelLayout[key].x + labelLayout[key].width) <=
                    newOpthon.grid.right
                  ) {
                    labelLayout[key].x = params.labelRect.x;
                    return {
                      x: params.labelRect.x,
                      y: params.labelRect.y,
                    };
                  }
                } else {
                  //优化 标签的位置显示
                  if (
                    this.echartsRef.current.offsetWidth -
                      (labelLayout[key].x + labelLayout[key].width) <=
                    newOpthon.grid.right
                  ) {
                    labelLayout[key].x -= Math.abs(
                      this.echartsRef.current.offsetWidth -
                        (labelLayout[key].x + labelLayout[key].width)
                    );
                  }
                  if (labelLayout[key].x <= newOpthon.grid.left) {
                    labelLayout[key].x = newOpthon.grid.left;
                  }

                  return {
                    x: labelLayout[key].x,
                    y: labelLayout[key].y,
                  };
                }
              }
              // return {
              //     x: params.labelRect.x,
              //     y: params.labelRect.y
              // }
            },
            name: legenddata[a1],
            label: {
              ...{},
              ..._.attrList.label,
              ...{
                show: !opt.chart_label ? false : opt.chart_label.enable,
                color: _.textColor,
                position: "right",
                formatter: (s) => {
                  return _._labelformatter(s, seriesdata);
                },
                emphasis: {
                  textStyle: {
                    fontSize:
                      _.attrList.label.fontSize +
                      (_.attrList.label.fontSize >= 22 ? 0 : 4),
                  },
                },
              },
            },
            itemStyle: {
              emphasis: {
                borderColor: BsyUtils.hexToRGBAStr(newOpthon.color[a1], 0.5),
                borderWidth: 6,
                label: {
                  fontSize:
                    _.attrList.label.fontSize +
                    (_.attrList.label.fontSize >= 22 ? 0 : 4),
                },
              },
              normal: {
                color: newOpthon.color[a1],
              },
            },
          };
          if (_.state.chartType === "area_chart") {
            tmp.areaStyle = {};
          }

          if (opt.column_type === "category") {
            tmp.coordinateSystem = "polar";
          }
          if (markLine) {
            tmp.markLine = markLine;
          }
          newOpthon.series.push(tmp);
        });
        break;
      }

      case "radar_chart": {
        //雷达图
        //echarts 雷达表默认数据 是逆时钟，需要手动处理数据顺序
        let indMax = 0;
        let indMin = 0;

        let d = [];
        let ind = [];
        let avg = 360 / legenddata.length; //计算每个轴之前占的角度 用于处理 标签的偏移
        BsyUtils.forEach(legenddata, (t, e) => {
          //处理数据排序
          let gg = [seriesdata[t][0]];
          let tmp11 = [].concat(seriesdata[t]);
          let tmp1 = tmp11.reverse();
          tmp1.splice(tmp1.length - 1, 1);
          gg = gg.concat(tmp1);

          let ggg = {
            value: gg,
            name: legenddata[t],
          };
          d.push(ggg);

          let tmpmax = Math.max.apply(null, gg);
          if (tmpmax > indMax) indMax = tmpmax;
          let tmpmin = Math.min.apply(null, gg);
          if (tmpmin < indMin) indMin = tmpmin;
        });

        if (BsyUtils.isArray(_.yAxes) && _.yAxes.length > 0) {
          if (_.yAxes[0].hasOwnProperty("max") && _.yAxes[0].max !== null)
            indMax = _.yAxes[0].max;
          if (_.yAxes[0].hasOwnProperty("min") && _.yAxes[0].max !== null)
            indMin = _.yAxes[0].min;
        }

        let nn = this._calculateValueNiceDomain(indMin, indMax);

        ind.push({
          name: xAxisData[0],
          max: nn[1],
          min: nn[0],
          axisLabel: {
            show: true,
            color: this.tickLabelColor,
            formatter: (value, index) => {
              let s = _.formatAxisValue(value);
              return s;
            },
          },
        });
        for (let index = xAxisData.length - 1; index > 0; index--) {
          ind.push({
            name: xAxisData[index],
            max: nn[1],
            min: nn[0],
          });
        }

        BsyUtils.forEach(d, (arg1, arg2) => {
          let datamap = [];
          BsyUtils.forEach(arg2.value, (carg1, carg2) => {
            datamap.push({
              value: carg2,
              name: ind[carg1].name,
            });
          });
          d[arg1].datamap = datamap;
        });

        newOpthon.series = [
          {
            data: d,
            type: "radar",
            color: this._getColors(),
            label: {
              ...{},
              ..._.attrList.label,
              ...{
                show: !!opt.chart_label.enable,
                color: _.textColor,
                formatter: (s) => {
                  return _._formatValue(s.value, s.dataIndex);
                },
              },
              emphasis: {
                textStyle: {
                  fontSize:
                    _.attrList.label.fontSize +
                    (_.attrList.label.fontSize >= 22 ? 0 : 4),
                },
              },
            },
            // labelLayout = (params) => {
            //     console.log(params)
            // }
            labelLine: {
              show: !!opt.chart_label.enable,
              length: 20,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            z: 5,
          },
        ];

        newOpthon.radar = {
          center: ["50%", "50%"],
          radius: "70%",
          splitNumber: 4,
          nameGap: 15,
          name: {
            show: true,
            fontSize: 10,
            textStyle: {
              color: this.tickLabelColor,
              padding: [-10, -10],
            },
          },
          axisLine: {
            lineStyle: {
              color: this.splitColor,
            },
          },
          axisTick: {
            show: true,
          },
          indicator: ind,
        };

        _._renderRadius(newOpthon, legenddata);
        newOpthon.tooltip.trigger = undefined;
        //echarts 雷达表默认数据 是逆时钟，需要手动处理数据顺序
        break;
      }
      case "pie_chart": {
        //饼图
        seriesdata = seriesdata || [];
        newOpthon.grid = {};
        let data = [];
        let tmpdata = JSON.parse(JSON.stringify(seriesdata));
        BsyUtils.forEach(tmpdata, (g1, g2) => {
          data.push({
            value: Math.abs(g2[0]),
            name: legenddata[g1],
          });
        });

        let roseType = "";
        let radius = [0, "40%"];

        if (opt.pie_type === "rose") {
          roseType = "radius";
          radius = ["20%", "40%"];
        } else if (opt.pie_type === "doughnut") {
          roseType = "";
          radius = ["20%", "40%"];
        }

        let res = _._renderPie(legenddata);
        radius[1] = res.radius;

        newOpthon.series = [
          {
            center: res.center,
            type: "pie",
            radius: radius,
            roseType: roseType,
            data: data,
            avoidLabelOverlap: false,
            axisTick: {
              show: true,
            },
            label: {
              ...{},
              ..._.attrList.label,
              ...{
                show: opt.chart_label.enable,

                formatter: (s) => {
                  let y = "";
                  if (opt.chart_label.enable) {
                    if (opt.chart_label.dimension) {
                      if (opt.chart_label.dimension.enable) y += s.name + " ";
                    }

                    if (opt.chart_label.value) {
                      if (opt.chart_label.value.enable)
                        y +=
                          _._formatValue(
                            seriesdata[s.dataIndex][0],
                            s.seriesIndex
                          ) + " ";
                    } else {
                      y +=
                        _._formatValue(
                          seriesdata[s.dataIndex][0],
                          s.seriesIndex
                        ) + " ";
                    }

                    if (opt.chart_label.value_percent) {
                      if (opt.chart_label.value_percent.enable)
                        y += "(" + s.percent + "%" + ")";
                    } else {
                      y += "(" + s.percent + "%" + ")";
                    }
                  }
                  return y;
                },
                emphasis: {
                  textStyle: {
                    fontSize:
                      _.attrList.label.fontSize +
                      (_.attrList.label.fontSize >= 22 ? 0 : 4),
                  },
                },
              },
            },
          },
        ];

        newOpthon.series[0].label.position &&
          delete newOpthon.series[0].label.position;
        newOpthon.tooltip.trigger = undefined;
        break;
      }
      case "funnel_chart": {
        //漏斗
        let sortByArr = (arr, rev) => {
          if (rev == undefined) {
            rev = 1;
          } else {
            rev = rev ? 1 : -1;
          }
          return (a, b) => {
            for (let i = 0; i < arr.length; i++) {
              let attr = arr[i];
              if (a[attr] != b[attr]) {
                if (a[attr] > b[attr]) {
                  return rev * 1;
                } else {
                  return rev * -1;
                }
              }
            }
          };
        };
        newOpthon.legend.data = xAxisData;
        newOpthon.tooltip.trigger = "item";
        let data = [];
        BsyUtils.forEach(seriesdata[0], (obj1, val1) => {
          if (val1 > 0) {
            data.push({
              value: val1,
              name: xAxisData[obj1],
            });
          }
        });
        data.sort(sortByArr(["value"], false));
        let grid = _._renderFunnel(xAxisData);

        newOpthon.series = [
          {
            // name:_.attrList.tooltip ? _.attrList.tooltip.seriesName ? _.attrList.tooltip.seriesName : "" : "",
            type: "funnel",
            top: grid.top,
            left: grid.left,
            right: grid.right,
            bottom: grid.bottom,
            sort: "none",
            minSize: "0%",
            gap: _.attrList.gap === undefined ? 1 : _.attrList.gap,
            orient: _.attrList.orient,
            label: {
              show: !!opt.chart_label.enable,
              position: "center", //_.attrList.label.position === "top" ? "center" : labelP,
              color: _.attrList.label.color,
              fontSize: _.attrList.label.fontSize,
              fontStyle: _.attrList.label.fontStyle,
              fontWeight: _.attrList.label.fontWeight,
              textStyle: {
                textBorderColor: "none",
              },
              formatter: (s) => {
                let y = s.name + " ";
                y += _._formatValue(s.value, s.dataIndex, data, s);
                return y;
              },
            },
            labelLine: {
              show: !!opt.chart_label.enable,
              length: 20,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            itemStyle: {
              borderColor: _.attrList.itemStyle.borderColor,
              borderWidth: _.attrList.itemStyle.borderWidth,
              emphasis: {
                label: {
                  fontSize:
                    _.attrList.label.fontSize +
                    (_.attrList.label.fontSize >= 22 ? 0 : 4),
                },
              },
            },
            data: data,
          },
        ];

        break;
      }
      case "gauge_chart": {
        //仪盘表
        // console.log(option, legenddata, xAxisData, seriesdata)
        const { range, attrList, valueFields } = this.state;
        let s = [],
          series = [],
          data = [],
          colors = [],
          range1 = range.split(",").map(Number),
          max = range1[range1.length - 1],
          min = range1[0];

        data.push({
          value: seriesdata[0],
          name: xAxisData[0],
        });

        colors = this._getColors();

        let pointerColor = this.props.pointerColor || "auto";
        if (pointerColor == "auto") {
          if (this.props.dashStyles && this.props.dashStyles.theme) {
            pointerColor = this.props.dashStyles.theme.highLightColor;
          }
        }

        series.push({
          type: "gauge",
          max: max,
          min: min,
          radius: "90%",
          center: ["50%", "55%"],
          itemStyle: {
            color: pointerColor,
          },
          axisLine: {
            lineStyle: {
              color: colors,
            },
          },
          title: {
            show: !0,
            padding: 5,
            textStyle: {
              color: this.tickLabelColor,
              // fontStyle:attrList.title.textStyle.fontStyle,
              fontSize: 10,
              // fontWeight:attrList.title.textStyle.fontWeight
            },
            left: "left", //'left', 'center', 'right'
            // borderColor:attrList.title.borderColor,
            // borderRadius:attrList.title.borderRadius,
            // backgroundColor:attrList.title.backgroundColor// 'rgba(128, 128, 128, 0.5)'
          },

          axisLabel: {
            show: true,
            color: this.tickLabelColor,
            fontSize: 10,
            // fontSize: attrList.label.fontSize,
            formatter: function (value, index) {
              let s = _.formatAxisValue(value);
              // yticks0.push(s);
              return s;
            },
          },
          detail: {
            show: !!this.props.chart_label.enable,
            color: this.textColor,
            fontSize: attrList.label.fontSize,
            fontStyle: attrList.label.fontStyle,
            fontWeight: attrList.label.fontWeight,
            formatter: function (s) {
              if (valueFields[0].format === "0.00%") {
                return _._formatValue(s / max, 0);
              } else {
                return _._formatValue(s, 0);
              }
            },
          },
          data: data,
        });

        let option1 = {
          backgroundColor: attrList.backgroundColor
            ? attrList.backgroundColor
            : "transparent",
          toolbox: {
            show: false,
            feature: {
              dataView: { readOnly: false },
              restore: {},
              saveAsImage: {},
            },
          },
          series: series,
        };

        newOpthon = { ...option1 };
        break;
      }
      default: {
        break;
      }
    }

    return { ...{}, ...newOpthon };
  };

  _getAxisDataLeng = (fontStyle) => {
    let h = this;
    let ret = 0;
    BsyUtils.forEach(h.chartUtils.category, function (a1, b1) {
      let len = BsyUtils.getTextPixelWith(
        b1,
        fontStyle || {
          fontFamily: "verdana",
          fontSize: 10,
          fontStyle: "normal",
          fontWeight: "normal",
        }
      );
      if (len > ret) {
        ret = len;
      }
    });
    return ret;
  };

  _addThresholdLine = () => {
    let markLine = {
      silent: true,
      symbol: "none",
      max: null,
      min: null,
    };
    let t = this.props,
      e = this,
      i = [],
      n = "left";
    const { valueFields } = this.state;

    t.isInverted && (n = "top");
    BsyUtils.forEach(t.guideline, function (r, a) {
      let o,
        s = e._getFirstValidFormatIndex(),
        h = "",
        l = "";
      if ("dynamic" === a.type) {
        let c = e.guidelineVal[a.field];
        o = c && c[a.aggregate];
        BsyUtils.forEach(valueFields, function (t, e) {
          if (a.field === e.tag) return (s = t), !1;
        });
      } else o = a.value;

      a.is_label_visible && (h = a.label);

      if (a.is_value_visible) {
        l = e._formatValue(o, s || 0);
        h += BsyUtils.isEmpty(h) ? l : "：" + l;
      }

      // a.is_value_visible && (l = e._formatValue(o, s),
      //     h += FX.Utils.isEmpty(h) ? l : "：" + l);
      if (markLine.max === null) {
        markLine.max = o;
      }
      if (markLine.min === null) {
        markLine.min = o;
      }
      if (o > markLine.max) {
        markLine.max = o;
      }
      if (o < markLine.min) {
        markLine.min = o;
      }

      i.push({
        yAxis: o,
        label: {
          position: "insideStartTop",
          color: a.color,
          formatter: h,
          fontSize: 10,
        },
        lineStyle: {
          color: a.color,
          type: "dashed",
        },
      });
    });
    BsyConfig().LimitFields.dashThresholds.indexOf(this.state.chartType) > -1 &&
      BsyUtils.forEach(t.thresholds, function (r, a) {
        if (a.enable) {
          let o,
            s = a.cond,
            h = s.value && s.value[0];
          BsyUtils.forEach(valueFields, function (t, e) {
            if (a.cond.field === e.tag) return (o = t), !1;
          });
          if (markLine.max === null) {
            markLine.max = o;
          }
          if (markLine.min === null) {
            markLine.min = o;
          }
          if (o > markLine.max) {
            markLine.max = o;
          }
          if (o < markLine.min) {
            markLine.min = o;
          }
          i.push({
            yAxis: o,
            label: {
              position: "insideStartTop",
              color: a.color,
              formatter: h,
              fontSize: 10,
            },
            lineStyle: {
              color: a.color,
              type: "dashed",
            },
          });
        }
      });
    if (BsyUtils.isObjectEmpty(i)) {
      markLine = false;
    } else {
      markLine.data = i;
      if (markLine.min == markLine.max) {
        //最大值最小值一样会导致y轴不显示
        if (markLine.max == 0) {
          markLine.max = 0.1;
        } else {
          // markLine.min = markLine.min - (Math.abs(markLine.min / 10) > 10 ? 10 : Math.abs(markLine.min / 10))
          markLine.max =
            markLine.max +
            (Math.abs(markLine.max / 10) > 10
              ? 10
              : Math.abs(markLine.max / 10));
        }
      }
    }

    return markLine;
  };

  doResize = () => {
    // this.ref.current.innerHTML = '';
    // this.renderGantt();
    this.asx_last = -1;
    // console.log(this.$body.width(),this.$body.height());
    if (this.myCharts) {
      let n = this.chartUtils;
      if (n) {
        let opt = {};
        switch (this.state.chartType) {
          case "map_chart": {
            this.myCharts.resize();
            break;
          }
          default: {
            opt = this._renderOptions({}, n.series, n.category, n.data);
            break;
          }
        }
        if (opt) this.myCharts.setOption(opt);
      }
      this.myCharts && this.myCharts.resize();
    }
  };

  reload = (options) => {
    if (options) {
      this.linkParam = options.filter;
    }

    this.setState(
      {
        ...this.state,
        ...options,
      },
      () => {
        this.loadData();
      }
    );
  };

  _getLinkFilterParams = (e) => {
    let i = this.props,
      n = [];
    BsyUtils.forEach(e, function (e, r) {
      n.push({
        ...BsyUtils.pick(r, [
          "method",
          "type",
          "value",
          "keyType",
          "subField",
          "subform",
          "field",
          "subform",
        ]),
        ...BsyUtils.dealFilterInfoByField({
          id: i.forms[0],
          name: r.field,
        }),
      });
    });
    return n;
  };
  _linearNiceDomain = (t, e, n) => {
    t = BsyUtils.accMul(Math.floor(t / n), n);
    e = BsyUtils.accMul(Math.ceil(e / n), n);
    return [t, e];
  };

  BBY_doSort = () => {
    const { valueFields } = this.state;
    let t = this.props,
      e = this,
      i = [],
      n = [];

    if (t.xFields.length) {
      i = BsyUtils.getDashSortFields(t.xFields).concat(
        BsyUtils.getDashQuotaSortFields(valueFields)
      );
      BsyUtils.forEach(i, function (t, e) {
        n.push(e.tag);
      });
    } else {
      2 === t.xFields.length && (i = BsyUtils.getDashSortFields(t.xFields));
    }

    // t.xFields.length <= 1 ? (i = BsyUtils.getDashSortFields(t.xFields).concat(BsyUtils.getDashQuotaSortFields(t.valueFields)),
    //     BsyUtils.forEach(i, function (t, e) {
    //         n.push(e.tag)
    //     })) : 2 === t.xFields.length && (i = BsyUtils.getDashSortFields(t.xFields));
    let r = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        e.dashChartSort = new window.FX.DashChartSortPane({
          renderEl: t,
          sorts: e.state.sort,
          fields: i,
          incompatibleTags: n,
          hideCustomSort: !0,
        });
      },
      onOk: function () {
        let t = e.dashChartSort.getSorts();
        e.hasSort = !0;
        e.setState(
          {
            sort: t,
          },
          () => {
            e.loadData();
          }
        );
        r.close();
      },
    });
    r.show();
  };

  showLoading = () => {
    const { isLoading } = this.state;
    if (!this.isDashFull) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={"skeletonspin"} /> : "";
    }
    if (
      !(
        this.props.autoRefresh &&
        this.props.autoRefresh &&
        this.props.autoRefresh.enabled
      )
    ) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={"skeletonspin"} /> : "";
    }
    return "";
  };

  render() {
    const { widgetId, dataEmpty } = this.state;
    return (
      <>
        <div
          className={"bsy-chart-body"}
          key={widgetId}
          ref={this.echartsRef}
          id={widgetId}
        ></div>
        {this.showLoading()}
        {dataEmpty ? (
          <div className={"chart-data-empty"}>
            <div>
              <i
                className={BsyUtils._getWidgetTypeIcon(this.state.chartType)}
              ></i>
              <span>{React.language("widget.linkdata.empty")}</span>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
}

export class DashChartUtils {
  constructor(props) {
    this.props = {
      ...{
        yGroups: [],
        xGroups: [],
        valueFields: [],
        data: {},
        userMap: {},
        departmentMap: {},
        flowIdNameMap: {},
      },
      ...props,
    };
  }

  getChartData = () => {
    let t = this.props;
    let _this = this;
    this.nameMap = {};
    this.flowIdNameMap = {};
    this.flowDecisionMap = {
      [React.language("filter.method.ep")]: 0,
      [React.language("approved")]: 1,
      [React.language("approval.rejected")]: 2,
    };

    BsyUtils.forEach(t.flowIdNameMap, function (a1, a2) {
      _this.flowIdNameMap[a2.value] = a2.text;
    });

    this.tags = [];
    this._createCategory(t.data.x, t.xGroups);
    this._createSeriesAndData(t.data.val, t.yGroups);
    return {
      category: this.category,
      series: this.series,
      data: this.data,
      nameMap: this.nameMap,
      tags: this.tags,
      flowDecisionMap: this.flowDecisionMap,
      flowIdNameMap: this.flowIdNameMap,
    };
  };
  _createCategory = (t, e) => {
    let i = this,
      n = this.props;
    this.category = [];
    let r = [];
    BsyUtils.forEach(t, function (t, e) {
      BsyUtils.forEach(e.data, function (t, e) {
        r[t] || (r[t] = []);
        r[t].push(e);
      });
    });
    BsyUtils.isObjectEmpty(e) && this.category.push(n.valueFields[0].title);
    BsyUtils.forEach(r, function (t, n) {
      i.category.push(i._getGroupText(n, e));
    });
  };
  _createSeriesAndData = (t, e) => {
    let i = this,
      n = this.props;
    this.series = [];
    this.data = [];
    BsyUtils.forEach(t, function (t, n) {
      e &&
        e.length &&
        (n.is_other_col
          ? i.series.push(React.language("other"))
          : i.series.push(i._getGroupText(n.y, e)));
      n.data.length ? i.data.push(n.data) : i.data.push([n.sum]);
      i.tags.push(n.tag);
    });
    if (!e || !e.length) {
      BsyUtils.forEach(n.valueFields, function (t, e) {
        !1 !== e.enable && i.series.push(e.title);
      });
    }
  };
  _getGroupText = (t, e) => {
    let i = this,
      n = this.props,
      r = "";
    BsyUtils.forEach(e, function (e, a) {
      let o = t[e];
      switch (a.type) {
        case "datetime":
          r = BsyUtils.date2GroupStr(o, a.groupRule);
          i.nameMap[r] = o;
          break;
        case "user":
        case "usergroup":
          let s = n.userMap[o];
          r = s.nickname || o;
          i.nameMap[r] = o;
          break;
        case "dept":
        case "deptgroup":
          let h = n.departmentMap[o];
          r = h.name || o;
          i.nameMap[r] = o;
          break;
        case "location":
        case "address":
          r = "";
          let l = [];
          if (BsyUtils.isEmpty(a.groupRule))
            switch (n.region) {
              case "province":
                l.push("city");
                break;
              case "city":
                l.push("district");
                break;
              default:
                l.push("province");
            }
          else l = a.groupRule.split("_");
          BsyUtils.forEach(l, function (t, e) {
            if (o) BsyUtils.isEmpty(o[e]) || (r += o[e]);
          });
          i.nameMap[r] = o;
          break;
        case "flowState":
        case "flowstate":
          let c = BsyConfig().CONST.WORKFLOW.FLOWSTATE,
            u = {};
          u[c.INPROCESS] = React.language("flow.state.inProcess");
          u[c.COMPLETE] = React.language("flow.state.complete");
          u[c.CLOSE] = React.language("flow.state.closed");
          r = u[o] || "";
          break;
        case "flowdecision":
        case "flowDecision":
          r = (o && o.text) || "";
          if (r) {
            i.flowDecisionMap[r] = parseInt(o.value);
          }
          break;
        case "assist_flowid":
          r = i.flowIdNameMap[o] || "";
          break;
        case "assist_prostatus":
          let l1 = {};
          l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS] = React.language(
            "mobile.flow.node.doing"
          );
          l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE] =
            React.language("processed");
          r = l1[o] || "";
          break;
        default:
          if ("creator" === a.name) {
            r = n.userMap[o].nickname;
            i.nameMap[r] = o;
          } else {
            r = o;
          }
          break;
      }
    });
    return r;
  };
}
